export const blogArticleTranslations = {
  cafe: {
    title: {
      EN: "Best Cafes in Miyakojima",
      中文: "宫古岛精选咖啡馆",
      한국어: "미야코지마 추천 카페",
    },
    text: {
      EN: "From ocean-view cafes to relaxing green spaces and rainy-day stops.",
      中文: "从海景咖啡馆到绿意空间、雨天也适合去的店铺。",
      한국어:
        "오션뷰 카페부터 초록이 있는 공간, 비 오는 날 들르기 좋은 곳까지 소개합니다.",
    },
    description: {
      EN: "A curated guide to Miyakojima cafes, including ocean-view cafes, relaxing green spaces, rainy-day cafes, local ingredients, and photogenic spots.",
      中文: "精选宫古岛旅行途中想去的咖啡馆，包括海景、绿意空间、雨天可去、岛食材和适合拍照的店铺。",
      한국어:
        "오션뷰, 초록이 있는 공간, 비 오는 날 가기 좋은 곳, 섬 식재료와 사진 찍기 좋은 카페를 엄선했습니다.",
    },
    leadText: {
      EN: "Miyakojima has many cafes where you can enjoy not only food, but also the view and atmosphere. This guide introduces ocean views, relaxing green spaces, rainy-day options, island ingredients, and photogenic cafes by category.",
      中文: "宫古岛有许多不只是用餐，还能连同景色和空间一起享受的咖啡馆。这里按类别介绍海景、绿意空间、雨天可去、岛食材和适合拍照的咖啡馆。",
      한국어:
        "미야코지마에는 음식뿐 아니라 풍경과 분위기까지 즐길 수 있는 카페가 많습니다. 오션뷰, 초록이 있는 공간, 비 오는 날, 섬 식재료, 사진 찍기 좋은 카페를 카테고리별로 소개합니다.",
    },
    toc: {
      EN: [
        "Ocean-view cafes",
        "Cafes surrounded by greenery",
        "Cafes for rainy days",
        "Cafes with Miyakojima ingredients",
        "Photogenic cafes",
      ],
      中文: [
        "海景咖啡馆",
        "绿意咖啡馆",
        "雨天也适合的咖啡馆",
        "品尝宫古岛食材",
        "适合拍照的咖啡馆",
      ],
      한국어: [
        "오션뷰 카페",
        "초록이 있는 카페",
        "비 오는 날 좋은 카페",
        "미야코지마 식재료 카페",
        "사진 찍기 좋은 카페",
      ],
    },
    points: [
      {
        title: {
          EN: "Ocean-view cafes",
          中文: "海景咖啡馆",
          한국어: "오션뷰 카페",
        },
        area: {
          EN: "Cafes with ocean views",
          中文: "看得见海的咖啡馆",
          한국어: "바다가 보이는 카페",
        },
        text: {
          EN: "Cafes where you can relax while looking at Miyakojima's blue ocean. Even a short stop during a drive or after beach time can make the trip feel richer.",
          中文: "可以一边眺望宫古岛蓝色大海一边放松的咖啡馆。自驾途中或海边活动前后顺路停留，也会让旅程更满足。",
          한국어:
            "미야코지마다운 푸른 바다를 바라보며 쉴 수 있는 카페입니다. 드라이브 중이나 바다놀이 전후에 들르는 것만으로도 여행 만족도가 올라갑니다.",
        },
      },
      {
        title: {
          EN: "Cafes surrounded by greenery",
          中文: "绿意咖啡馆",
          한국어: "초록이 있는 카페",
        },
        area: {
          EN: "Nature cafes",
          中文: "感受自然的咖啡馆",
          한국어: "자연을 느끼는 카페",
        },
        text: {
          EN: "Miyakojima is not only about the ocean. Cafes surrounded by greenery and flowers are perfect for hot days or slower, quieter moments.",
          中文: "宫古岛不只有海。被绿植和花包围的咖啡馆，很适合太阳强烈的日子或想安静放松的时候。",
          한국어:
            "미야코지마의 매력은 바다만이 아닙니다. 초록과 꽃으로 둘러싸인 카페는 햇살이 강한 날이나 조금 차분히 보내고 싶은 날에 좋습니다.",
        },
      },
      {
        title: {
          EN: "Cafes for rainy days",
          中文: "雨天也适合的咖啡馆",
          한국어: "비 오는 날 좋은 카페",
        },
        area: {
          EN: "How to spend bad-weather days",
          中文: "天气不好时的过法",
          한국어: "날씨가 좋지 않은 날의 보내는 법",
        },
        text: {
          EN: "Even when it rains, cafe time can keep the trip enjoyable. Choose places where you can sit indoors and enjoy coffee, lunch, or light snacks.",
          中文: "即使宫古岛下雨，善用咖啡馆时间也能继续享受旅行。选择能在室内慢慢坐着喝咖啡、吃午餐或轻食的店最合适。",
          한국어:
            "비 오는 미야코지마에서도 카페 시간을 잘 활용하면 여행을 즐길 수 있습니다. 실내에서 편하게 머물며 커피, 점심, 가벼운 음식을 즐길 수 있는 곳을 고르는 것이 좋습니다.",
        },
      },
      {
        title: {
          EN: "Cafes with Miyakojima ingredients",
          中文: "品尝宫古岛食材",
          한국어: "미야코지마 식재료 카페",
        },
        area: {
          EN: "Island ingredients and fruit",
          中文: "岛食材・水果",
          한국어: "섬 식재료・과일",
        },
        text: {
          EN: "If you want to taste Miyakojima, try cafes using island vegetables, mangoes, and tropical fruits.",
          中文: "想品尝宫古岛风味，可以选择使用岛野菜、芒果和南国水果的咖啡馆。",
          한국어:
            "미야코지마다운 맛을 즐기고 싶다면 섬 채소, 망고, 남국 과일을 사용한 카페를 추천합니다.",
        },
      },
      {
        title: {
          EN: "Photogenic cafes",
          中文: "适合拍照的咖啡馆",
          한국어: "사진 찍기 좋은 카페",
        },
        area: {
          EN: "Cafes to capture in photos and videos",
          中文: "想用照片和视频记录的咖啡馆",
          한국어: "사진과 영상으로 남기고 싶은 카페",
        },
        text: {
          EN: "For travel photos and videos, choose cafes with good color, background, and light. Capture not only drinks and sweets, but also the exterior and scenery around the cafe.",
          中文: "如果想把旅行回忆拍成照片或视频，推荐选择色彩、背景和光线都好的咖啡馆。不只饮品甜点，外观和周围景色也一起拍会更有氛围。",
          한국어:
            "여행의 추억을 사진과 영상으로 남기고 싶다면 색, 배경, 빛이 좋은 카페를 추천합니다. 음료와 디저트뿐 아니라 외관과 주변 풍경까지 함께 담으면 좋습니다.",
        },
      },
    ],
  },
  "bae-cafe-best5": {
    title: {
      EN: "Top 6 Photogenic Cafes in Miyakojima",
      中文: "宫古岛拍照好看的咖啡馆BEST6",
      한국어: "미야코지마 사진 맛집 카페 BEST 6",
    },
    text: {
      EN: "Six cafes where the sea, greenery, and tropical mood look beautiful in photos and videos.",
      中文: "精选6家适合把海、绿意和南国氛围拍进照片与视频的咖啡馆。",
      한국어:
        "바다, 초록, 남국 분위기를 사진과 영상으로 남기기 좋은 카페 6곳입니다.",
    },
    description: {
      EN: "A curated list of six photogenic cafes in Miyakojima, perfect for travel photos and videos.",
      中文: "精选宫古岛6家适合旅行拍照和视频记录的咖啡馆。",
      한국어:
        "여행 사진과 영상으로 남기기 좋은 미야코지마 감성 카페 6곳을 소개합니다.",
    },
    leadText: {
      EN: "When visiting cafes in Miyakojima, the scenery and atmosphere matter as much as the taste. Here are six cafes where ocean views, tropical greenery, colorful exteriors, drinks, and sweets are easy to capture beautifully.",
      中文: "在宫古岛逛咖啡馆，不只味道重要，想拍下来的景色和空间也很重要。这里精选海景、绿意、彩色外观、饮品甜点都好拍的6家咖啡馆。",
      한국어:
        "미야코지마 카페는 맛뿐 아니라 사진으로 남기고 싶은 풍경과 공간도 중요합니다. 바다 전망, 초록, 컬러풀한 외관, 예쁜 음료와 디저트를 찍기 좋은 카페 6곳을 골랐습니다.",
    },
    toc: {
      EN: [
        "Sea Horse Club Cafe",
        "OHAMA Terrace",
        "Panipani",
        "Blue Seal Miyakojima Painagama",
        "Shima cafe Tounkaraya",
      ],
      中文: [
        "Sea Horse Club Cafe",
        "OHAMA Terrace",
        "Panipani",
        "Blue Seal宫古岛Painagama店",
        "岛cafe Tounkaraya",
      ],
      한국어: [
        "Sea Horse Club Cafe",
        "OHAMA 테라스",
        "파니파니",
        "블루씰 미야코지마 파이나가마점",
        "시마 cafe 토운카라야",
      ],
    },
    points: [
      {
        text: {
          EN: "An open resort-like cafe with a pool, perfect for photos that capture Miyakojima's relaxed island mood.",
          中文: "带泳池的开放式空间，很适合拍出宫古岛度假感的照片。",
          한국어:
            "수영장이 있는 개방감 있는 공간으로, 미야코지마다운 리조트 분위기를 사진으로 남기기 좋습니다.",
        },
      },
      {
        text: {
          EN: "A terrace cafe overlooking Ikema Island's ocean. Place food or drinks in the foreground with Miyako blue behind them for an easy travel photo.",
          中文: "可以眺望池间岛大海的露台咖啡馆。把料理或饮品放在前景，背景放入宫古蓝，就能拍出旅行感。",
          한국어:
            "이케마섬 바다를 한눈에 볼 수 있는 테라스 카페입니다. 음식이나 음료를 앞에 두고 뒤로 미야코 블루를 넣으면 여행다운 사진이 됩니다.",
        },
      },
      {
        text: {
          EN: "A unique cafe surrounded by Kurima Island greenery. Use swings and natural backgrounds for a Miyakojima photo that feels different from the beach.",
          中文: "被来间岛绿意包围、很有世界观的咖啡馆。利用秋千座位和自然背景，可以拍出不同于海边的宫古岛照片。",
          한국어:
            "쿠리마섬의 초록에 둘러싸인 독특한 분위기의 카페입니다. 그네 좌석과 자연 배경을 활용하면 바다와는 다른 미야코지마 사진을 남길 수 있습니다.",
        },
      },
      {
        text: {
          EN: "A colorful ice cream stop near Painagama. It is easy to visit on rainy days or after the beach.",
          中文: "位于Painagama附近的彩色冰淇淋店。雨天或海边活动后也很适合顺路去。",
          한국어:
            "파이나가마 주변에서 컬러풀한 아이스크림을 즐기기 좋은 곳입니다. 비 오는 날이나 바다놀이 후에도 들르기 쉽습니다.",
        },
      },
      {
        text: {
          EN: "A cafe with ocean views from a hill. Shoot from the terrace or angles where the sea appears in the frame for a calm Miyakojima mood.",
          中文: "位于高处、可以俯瞰大海的咖啡馆。利用露台座位或能看到海的角度拍摄，能留下宫古岛温柔的氛围。",
          한국어:
            "언덕 위에서 바다를 내려다볼 수 있는 카페입니다. 테라스석이나 바다가 보이는 각도로 찍으면 미야코지마다운 차분한 분위기가 남습니다.",
        },
      },
    ],
  },
  "recommend-lunch": {
    title: {
      EN: "Recommended Lunch and Food in Miyakojima",
      中文: "宫古岛推荐午餐与美食",
      한국어: "미야코지마 추천 점심과 맛집",
    },
    text: {
      EN: "Curry, island-ingredient lunches, cafe meals, and meat dishes to try during your trip.",
      中文: "介绍咖喱、岛食材午餐、咖啡馆餐点和肉料理等旅行中想去的午餐店。",
      한국어:
        "카레, 섬 식재료 점심, 카페 밥, 고기 요리까지 여행 중 들르기 좋은 점심 맛집입니다.",
    },
    description: {
      EN: "A Miyakojima lunch guide covering curry, local ingredients, cafe meals, ramen, burgers, and grilled dishes.",
      中文: "宫古岛午餐指南，涵盖咖喱、岛食材、咖啡馆餐、拉面、汉堡和烤肉料理。",
      한국어:
        "카레, 섬 식재료, 카페 식사, 라멘, 버거, 그릴 요리까지 담은 미야코지마 점심 가이드입니다.",
    },
    leadText: {
      EN: "Here are lunch spots to keep in mind during your Miyakojima trip, from curry and cafe meals to ramen, burgers, and hearty meat dishes.",
      中文: "这里整理了宫古岛旅行中适合午餐的店铺，从咖喱、咖啡馆餐，到拉面、汉堡和肉料理都有。",
      한국어:
        "미야코지마 여행 중 점심으로 들르기 좋은 곳을 정리했습니다. 카레와 카페 식사부터 라멘, 버거, 든든한 고기 요리까지 포함했습니다.",
    },
    toc: {
      EN: [
        "Curry and spice lunch",
        "Cafe meals with island time",
        "Meat and grill lunch",
      ],
      中文: [
        "咖喱・香料系午餐",
        "享受岛时间的咖啡馆餐",
        "想吃饱时的肉・烧烤系午餐",
      ],
      한국어: [
        "카레・스파이스 점심",
        "섬 시간을 즐기는 카페 식사",
        "든든하게 먹는 고기・그릴 점심",
      ],
    },
  },
  "recommend-soba": {
    title: {
      EN: "5 Great Places for Miyako Soba",
      中文: "宫古荞麦面推荐5选",
      한국어: "미야코 소바 맛집 5선",
    },
    text: {
      EN: "Easy city spots, northern drive stops, and southern-area Miyako soba restaurants.",
      中文: "介绍市区方便前往、北部自驾和南部方向适合顺路去的宫古荞麦面店。",
      한국어:
        "시내에서 가기 쉬운 곳부터 북부 드라이브, 남부 코스에 들르기 좋은 미야코 소바집까지 소개합니다.",
    },
    description: {
      EN: "Five Miyako soba restaurants to try around the city, northern Miyakojima, and the southern area.",
      中文: "精选市区、北部和南部方向值得品尝的5家宫古荞麦面店。",
      한국어:
        "시내, 북부, 남부에서 들르기 좋은 미야코 소바집 5곳을 소개합니다.",
    },
    leadText: {
      EN: "Miyako soba is one of the foods you should try on the island. This guide groups restaurants by city, northern drive routes, and southern areas.",
      中文: "宫古荞麦面是来岛上想尝试的代表美食之一。这里按市区、北部自驾路线和南部方向整理推荐店铺。",
      한국어:
        "미야코 소바는 섬에서 꼭 먹어보고 싶은 대표 음식 중 하나입니다. 시내, 북부 드라이브, 남부 방면으로 나누어 소개합니다.",
    },
    toc: {
      EN: [
        "Miyako soba in the city area",
        "Northern and Ikema-area soba",
        "Southern and Gusukube-area soba",
      ],
      中文: [
        "市区方便前往的宫古荞麦面",
        "北部・池间方向想去的宫古荞麦面",
        "南部・城边方向想吃的宫古荞麦面",
      ],
      한국어: [
        "시내에서 가기 쉬운 미야코 소바",
        "북부・이케마 방면 미야코 소바",
        "남부・구스쿠베 방면 미야코 소바",
      ],
    },
  },
  "recommend-sata-andagi": {
    title: {
      EN: "5 Sata Andagi Shops in Miyakojima",
      中文: "宫古岛萨塔安达吉推荐5选",
      한국어: "미야코지마 사타안다기 추천 5곳",
    },
    text: {
      EN: "Five shops to try for sata andagi and satapanbin during your Miyakojima trip.",
      中文: "宫古岛旅行中想吃萨塔安达吉和satapanbin时推荐的5家店。",
      한국어:
        "미야코지마 여행 중 사타안다기와 사타판빈을 먹고 싶을 때 추천하는 5곳입니다.",
    },
    description: {
      EN: "A guide to five recommended sata andagi and satapanbin shops in Miyakojima, including Shichifuku Satapanbin, a lesser-known local spot.",
      中文: "介绍宫古岛推荐的5家萨塔安达吉和satapanbin店，包括当地穴场七福satapanbin。",
      한국어:
        "현지인들이 찾는 숨은 가게 시치후쿠 사타판빈을 포함해 미야코지마 사타안다기 추천 5곳을 소개합니다.",
    },
    leadText: {
      EN: "Sata andagi is perfect as a snack during a drive or as a souvenir. Here are shops to visit around Irabu Island and beyond.",
      中文: "萨塔安达吉很适合自驾途中当小点心，也适合作为伴手礼。这里介绍伊良部岛周边值得顺路去的店铺。",
      한국어:
        "사타안다기는 드라이브 중 간식이나 기념품으로 좋습니다. 이라부섬 주변에서 들르기 좋은 가게를 소개합니다.",
    },
    toc: {
      EN: ["5 places for sata andagi"],
      中文: ["萨塔安达吉推荐5选"],
      한국어: ["사타안다기 추천 5선"],
    },
  },
  "drive-scenic-spots": {
    title: {
      EN: "9 Scenic Spots You Can Visit by Car in Miyakojima",
      中文: "宫古岛开车可到的9个绝景地点",
      한국어: "미야코지마에서 차로 갈 수 있는 절경 스팟 9선",
    },
    text: {
      EN: "Scenic views, sunset spots, bridges, and beaches that are easy to visit by car.",
      中文: "介绍开车可到的绝景、夕阳景点、桥梁和海滩。",
      한국어: "차로 갈 수 있는 절경, 석양 명소, 다리와 해변을 소개합니다.",
    },
    description: {
      EN: "A driving guide to Miyakojima scenic spots, including blue ocean gradients, bridges, white sand beaches, and sunset views.",
      中文: "宫古岛自驾绝景指南，包含海色渐层、桥梁、白沙海滩和夕阳景点。",
      한국어:
        "바다 그라데이션, 다리, 하얀 모래 해변, 석양 명소까지 담은 미야코지마 드라이브 절경 가이드입니다.",
    },
    leadText: {
      EN: "Miyakojima has many scenic spots that are easy to reach by car, from bridges over Miyako blue waters to white sand beaches, dramatic capes, and sunset locations.",
      中文: "宫古岛有许多开车就能抵达并令人感动的绝景，包括宫古蓝大海上的桥、白沙海滩、岬角和夕阳景点。",
      한국어:
        "미야코지마에는 차로 쉽게 갈 수 있는 절경이 많습니다. 미야코 블루를 바라보는 다리, 하얀 모래 해변, 곶, 석양 명소까지 정리했습니다.",
    },
    toc: {
      EN: [
        "Irabu Bridge",
        "Yonaha Maehama Beach",
        "Sunayama Beach",
        "17END",
        "Higashi-Hennazaki",
        "Painagama Beach",
        "Makiyama Observatory",
        "Sawada Beach",
        "To River Sunset Beach",
      ],
      中文: [
        "伊良部大桥",
        "与那霸前滨海滩",
        "砂山海滩",
        "17END",
        "东平安名崎",
        "Painagama海滩",
        "牧山展望台",
        "佐和田之滨",
        "To River夕阳海滩",
      ],
      한국어: [
        "이라부대교",
        "요나하 마에하마 해변",
        "스나야마 해변",
        "17END",
        "히가시헨나자키",
        "파이나가마 해변",
        "마키야마 전망대",
        "사와다노하마",
        "투리버 선셋 비치",
      ],
    },
    spots: [
      {
        title: { EN: "Irabu Bridge", 中文: "伊良部大桥", 한국어: "이라부대교" },
        area: {
          EN: "Miyako Island to Irabu Island",
          中文: "宫古岛〜伊良部岛",
          한국어: "미야코섬〜이라부섬",
        },
        text: {
          EN: "A classic driving spot where the road feels like it runs straight over Miyako blue water. Just crossing the bridge gives you a true Miyakojima view.",
          中文: "经典自驾景点，道路仿佛笔直穿过宫古蓝的大海。开车经过也能感受到宫古岛的绝景。",
          한국어:
            "미야코 블루 바다 위를 곧게 달리는 듯한 대표 드라이브 스팟입니다. 다리를 건너는 것만으로도 미야코지마다운 절경을 느낄 수 있습니다.",
        },
      },
      {
        title: {
          EN: "Yonaha Maehama Beach",
          中文: "与那霸前滨海滩",
          한국어: "요나하 마에하마 해변",
        },
        area: {
          EN: "Southwest Miyakojima",
          中文: "宫古岛西南部",
          한국어: "미야코지마 남서부",
        },
        text: {
          EN: "A popular beach with white sand and clear water. It is easy to reach by car and looks beautiful both in the daytime and around sunset.",
          中文: "拥有白沙和高透明度海水的人气海滩。开车方便抵达，白天和傍晚都很美。",
          한국어:
            "하얀 모래와 투명한 바다가 펼쳐지는 인기 해변입니다. 차로 접근하기 쉽고 낮과 저녁 분위기 모두 아름답습니다.",
        },
      },
      {
        title: {
          EN: "Sunayama Beach",
          中文: "砂山海滩",
          한국어: "스나야마 해변",
        },
        area: {
          EN: "Northern Miyakojima",
          中文: "宫古岛北部",
          한국어: "미야코지마 북부",
        },
        text: {
          EN: "After crossing the sandy hill, the ocean and rock arch open up in front of you. It is a great spot for natural-looking photos.",
          中文: "越过沙丘后，眼前就是大海和岩石拱门。适合拍摄自然感强的照片。",
          한국어:
            "모래 언덕을 넘으면 바다와 바위 아치가 펼쳐지는 인기 스팟입니다. 자연스러운 사진을 남기고 싶은 분께 좋습니다.",
        },
      },
    ],
  },
  "model-course-2n3d": {
    title: {
      EN: "2-Night, 3-Day Miyakojima Model Plan",
      中文: "宫古岛2晚3天旅行计划",
      한국어: "미야코지마 2박 3일 모델 플랜",
    },
    text: {
      EN: "A 2-night plan with a photo tour or hidden SUP, Yabiji, sunset, and dinner.",
      中文: "包含绝景摄影或秘境SUP、八重干濑、夕阳和晚餐的2晚3天计划。",
      한국어:
        "절경 촬영 투어 또는 비경 SUP, 야비지, 석양, 저녁 식사를 담은 2박 3일 플랜입니다.",
    },
    description: {
      EN: "A 2-night, 3-day Miyakojima itinerary combining a scenic photo tour, hidden SUP, Yabiji, sunset, dinner, beaches, and cafes.",
      中文: "结合绝景摄影、秘境SUP、八重干濑、夕阳、晚餐、海滩和咖啡馆的宫古岛2晚3天行程。",
      한국어:
        "절경 촬영, 비경 SUP, 야비지, 석양, 저녁 식사, 해변과 카페를 조합한 미야코지마 2박 3일 일정입니다.",
    },
    leadText: {
      EN: "For two nights in Miyakojima, start with a photo tour or hidden SUP, enjoy Yabiji and sunset on day two, then keep the final day relaxed with beaches and cafes before heading to the airport.",
      中文: "宫古岛2晚旅行，第一天安排绝景摄影或秘境SUP，第二天享受八重干濑和夕阳，最后一天在海滩和咖啡馆慢慢度过后前往机场。",
      한국어:
        "미야코지마 2박 여행이라면 첫날은 절경 촬영 투어 또는 비경 SUP, 둘째 날은 야비지와 석양, 마지막 날은 해변과 카페에서 여유롭게 보내고 공항으로 향하는 흐름이 좋습니다.",
    },
    toc: {
      EN: [
        "Day 1: Scenic photo tour or hidden SUP",
        "Day 2: Yabiji tour, sunset, and dinner",
        "Day 3: Relax at beaches and cafes, then airport",
      ],
      中文: [
        "第1天：绝景摄影或秘境SUP",
        "第2天：八重干濑行程、夕阳与晚餐",
        "第3天：海滩和咖啡馆慢慢过，前往机场",
      ],
      한국어: [
        "1일차: 절경 촬영 투어 또는 비경 SUP",
        "2일차: 야비지 투어, 석양, 저녁 식사",
        "3일차: 해변과 카페에서 여유롭게, 공항으로",
      ],
    },
    points: [
      {
        title: {
          EN: "Day 1: Scenic photo tour or hidden SUP",
          中文: "第1天：绝景摄影或秘境SUP",
          한국어: "1일차: 절경 촬영 투어 또는 비경 SUP",
        },
        text: {
          EN: "Begin the trip with a scenic photo tour or hidden SUP. Starting with a memorable experience makes the whole trip feel more special.",
          中文: "旅程开始可以选择绝景摄影行程或秘境SUP。第一天就留下照片和视频，会让整趟旅行更特别。",
          한국어:
            "여행의 시작은 절경 촬영 투어 또는 비경 SUP가 좋습니다. 첫날부터 사진과 영상을 남기면 여행 전체의 만족감이 더 커집니다.",
        },
      },
      {
        title: {
          EN: "Day 2: Yabiji tour, sunset, and dinner",
          中文: "第2天：八重干濑行程、夕阳与晚餐",
          한국어: "2일차: 야비지 투어, 석양, 저녁 식사",
        },
        text: {
          EN: "Spend the morning at Yabiji, watch the sunset in the evening, then enjoy Miyakojima dinner such as island food, izakaya, or yakiniku.",
          中文: "上午去八重干濑，傍晚看夕阳，晚上享受岛料理、居酒屋或烤肉等宫古岛晚餐。",
          한국어:
            "아침에는 야비지 투어를 즐기고, 저녁에는 석양을 본 뒤 섬 음식, 이자카야, 야키니쿠 등 미야코지마의 밤 식사를 즐겨보세요.",
        },
      },
      {
        title: {
          EN: "Day 3: Relax at beaches and cafes, then airport",
          中文: "第3天：海滩和咖啡馆慢慢过，前往机场",
          한국어: "3일차: 해변과 카페에서 여유롭게, 공항으로",
        },
        text: {
          EN: "On the final day, avoid going too far. Relax at a beach or cafe, buy souvenirs, and leave enough time for the airport.",
          中文: "最后一天不要走太远。可以在海滩或咖啡馆慢慢过，买伴手礼，并预留足够时间前往机场。",
          한국어:
            "마지막 날은 멀리 이동하지 않고 해변이나 카페에서 여유롭게 보내며 기념품을 사고 공항 시간을 넉넉히 잡는 것이 좋습니다.",
        },
      },
    ],
  },
  "without-car-plan": {
    title: {
      EN: "A One-Day Miyakojima Plan Without a Car",
      中文: "没有租车也能享受宫古岛的一日行程",
      한국어: "차 없이 즐기는 미야코지마 하루 코스",
    },
    text: {
      EN: "A relaxed plan around the city, nearby beaches, cafes, and sunset spots.",
      中文: "以市区、近处海滩、咖啡馆和夕阳为中心的轻松一日路线。",
      한국어:
        "시내, 가까운 해변, 카페, 석양 명소를 중심으로 한 여유로운 하루 코스입니다.",
    },
    description: {
      EN: "A Miyakojima itinerary for travelers without a rental car, focused on easy-to-reach areas.",
      中文: "为没有租车的旅客整理的宫古岛行程，以容易抵达的区域为中心。",
      한국어:
        "렌터카 없이도 즐기기 쉬운 지역을 중심으로 정리한 미야코지마 일정입니다.",
    },
    leadText: {
      EN: "A car is convenient in Miyakojima, but you can still enjoy the island by focusing on the city area, Painagama, cafes, and local food.",
      中文: "宫古岛有车会更方便，但即使没有租车，只要集中在市区、Painagama、咖啡馆和美食，也能好好享受岛时间。",
      한국어:
        "미야코지마는 차 이동이 편하지만, 시내와 파이나가마, 카페와 맛집을 중심으로 잡으면 차 없이도 충분히 즐길 수 있습니다.",
    },
    toc: {
      EN: [
        "Morning: Breakfast and walking around town",
        "Lunch: Nearby cafes and restaurants",
        "Evening: Sunset around Painagama",
      ],
      中文: [
        "上午：市区早餐与散步",
        "中午：附近咖啡馆与午餐",
        "傍晚：Painagama附近看夕阳",
      ],
      한국어: [
        "오전: 시내 주변 아침 식사와 산책",
        "점심: 가까운 카페와 식당",
        "저녁: 파이나가마 주변 석양",
      ],
    },
    points: [
      {
        title: {
          EN: "Morning: Breakfast and walking around town",
          中文: "上午：市区早餐与散步",
          한국어: "오전: 시내 주변 아침 식사와 산책",
        },
        text: {
          EN: "Start with breakfast near your hotel or in town, then slowly visit cafes and shops within walking distance.",
          中文: "先在酒店附近或市区吃早餐，再慢慢逛步行范围内的咖啡馆和小店。",
          한국어:
            "호텔 주변이나 시내에서 아침을 먹고, 걸어서 갈 수 있는 카페와 상점을 천천히 둘러보는 것을 추천합니다.",
        },
      },
      {
        title: {
          EN: "Lunch: Nearby cafes and restaurants",
          中文: "中午：附近咖啡馆与午餐",
          한국어: "점심: 가까운 카페와 식당",
        },
        text: {
          EN: "For lunch, choose city restaurants or cafes to keep travel easy. Pick ocean views on sunny days and indoor comfort on rainy days.",
          中文: "午餐以市区餐厅或咖啡馆为中心会更轻松。晴天选海景，雨天选室内舒适的店。",
          한국어:
            "점심은 시내 식당이나 카페를 중심으로 고르면 이동이 편합니다. 맑은 날은 바다가 보이는 곳, 비 오는 날은 실내가 편한 곳이 좋습니다.",
        },
      },
      {
        title: {
          EN: "Evening: Sunset around Painagama",
          中文: "傍晚：Painagama附近看夕阳",
          한국어: "저녁: 파이나가마 주변 석양",
        },
        text: {
          EN: "In the evening, head toward Painagama or To River. These areas are easy to reach from town and good for sunset photos.",
          中文: "傍晚前往Painagama或To River一带。从市区较容易抵达，也适合边看夕阳边拍照。",
          한국어:
            "저녁에는 파이나가마나 투리버 방면으로 가보세요. 시내에서 비교적 접근하기 쉽고 석양 사진을 남기기 좋은 지역입니다.",
        },
      },
    ],
  },
  "beach-best5": {
    title: {
      EN: "5 Beaches to Visit on Your First Miyakojima Trip",
      中文: "第一次来宫古岛想去的5个海滩",
      한국어: "처음 미야코지마에서 가고 싶은 해변 5선",
    },
    text: {
      EN: "Five classic beaches that are easy to visit and beautiful to photograph.",
      中文: "精选5个方便前往、也适合拍照记录的经典海滩。",
      한국어:
        "처음 방문해도 가기 쉽고 사진으로 남기기 좋은 대표 해변 5곳입니다.",
    },
    description: {
      EN: "A guide to five must-visit Miyakojima beaches, including Yonaha Maehama, Sunayama, and 17END.",
      中文: "介绍与那霸前滨、砂山、17END等第一次来宫古岛值得去的5个海滩。",
      한국어:
        "요나하 마에하마, 스나야마, 17END 등 처음 미야코지마에서 가기 좋은 해변 5곳입니다.",
    },
    leadText: {
      EN: "The easiest way to feel Miyakojima is through its beaches. Here are five easy-to-visit beaches that are beautiful for photos and videos.",
      中文: "最容易感受宫古岛魅力的，还是美丽的海滩。这里精选5个第一次旅行也容易去、适合拍照和视频记录的海滩。",
      한국어:
        "미야코지마의 매력을 가장 쉽게 느끼는 곳은 역시 아름다운 해변입니다. 처음 여행에도 가기 쉽고 사진과 영상으로 남기기 좋은 5곳을 골랐습니다.",
    },
    toc: {
      EN: [
        "Yonaha Maehama",
        "Sunayama Beach",
        "17END",
        "Sawada Beach",
        "Aragusuku Beach",
      ],
      中文: ["与那霸前滨", "砂山海滩", "17END", "佐和田之滨", "新城海岸"],
      한국어: [
        "요나하 마에하마",
        "스나야마 해변",
        "17END",
        "사와다노하마",
        "아라구스쿠 해안",
      ],
    },
    points: [
      {
        title: {
          EN: "Yonaha Maehama Beach",
          中文: "与那霸前滨海滩",
          한국어: "요나하 마에하마 해변",
        },
        text: {
          EN: "A signature Miyakojima beach with white sand and clear water. It is a must-see for first-time visitors.",
          中文: "宫古岛代表性海滩，拥有白沙和高透明度海水。第一次来宫古岛很值得去。",
          한국어:
            "하얀 모래와 투명한 바다가 펼쳐지는 미야코지마 대표 해변입니다. 처음 방문한다면 한 번은 보고 싶은 곳입니다.",
        },
      },
      {
        title: {
          EN: "Sunayama Beach",
          中文: "砂山海滩",
          한국어: "스나야마 해변",
        },
        text: {
          EN: "A popular spot where the ocean appears after you cross the sandy hill. Great for natural-looking photos.",
          中文: "越过沙坡后大海突然出现的人气景点。适合拍摄自然感照片。",
          한국어:
            "모래 언덕을 넘으면 바다가 펼쳐지는 인기 스팟입니다. 자연스러운 사진을 남기기 좋습니다.",
        },
      },
      {
        title: { EN: "17END", 中文: "17END", 한국어: "17END" },
        text: {
          EN: "A famous Shimoji Island spot with shallow blue gradients. The color is especially beautiful at low tide and on sunny days.",
          中文: "下地岛人气景点，远浅海面的蓝色渐层非常美。退潮和晴天时尤其漂亮。",
          한국어:
            "얕은 바다의 그라데이션이 아름다운 시모지섬 인기 스팟입니다. 간조와 맑은 시간대에 특히 바다색이 잘 보입니다.",
        },
      },
      {
        title: {
          EN: "Sawada Beach",
          中文: "佐和田之滨",
          한국어: "사와다노하마",
        },
        text: {
          EN: "A beach known for rocks scattered across the water. It has a beautiful mood in the daytime and at sunset.",
          中文: "海面上点缀着岩石的海滩。白天很美，傍晚夕阳时氛围也会变得特别。",
          한국어:
            "바다 위에 바위가 점점이 떠 있는 인상적인 해변입니다. 낮에도 아름답지만 석양 시간에는 분위기가 확 달라집니다.",
        },
      },
      {
        title: {
          EN: "Aragusuku Beach",
          中文: "新城海岸",
          한국어: "아라구스쿠 해안",
        },
        text: {
          EN: "A beach often associated with snorkeling and ocean activities. Always check local rules and sea conditions before entering the water.",
          中文: "以浮潜和海上活动闻名的海岸。下海前请务必确认规则和海况，安全第一。",
          한국어:
            "스노클링과 해양 액티비티 이미지가 강한 해변입니다. 바다에 들어갈 때는 현지 규칙과 해황을 꼭 확인하세요.",
        },
      },
    ],
  },
  "sunset-spots-best5": {
    title: {
      EN: "5 Recommended Sunset Spots in Miyakojima",
      中文: "宫古岛推荐夕阳景点5选",
      한국어: "미야코지마 추천 선셋 스팟 5선",
    },
    text: {
      EN: "A guide to beautiful sunset spots such as 17END, Sawada Beach, and To River.",
      中文: "介绍17END、佐和田之滨、To River等夕阳美丽的景点。",
      한국어:
        "17END, 사와다노하마, 투리버 등 석양이 아름다운 장소를 소개합니다.",
    },
    description: {
      EN: "Five recommended places to watch the sunset in Miyakojima, including 17END, Sawada Beach, To River Sunset Beach, Painagama Beach, and Nagamahama.",
      中文: "介绍宫古岛适合看夕阳的5个推荐地点，包括17END、佐和田之滨、To River Sunset Beach、Painagama Beach和长间滨。",
      한국어:
        "17END, 사와다노하마, 투리버 선셋 비치, 파이나가마 비치, 나가마하마 등 미야코지마 선셋 추천 장소 5곳입니다.",
    },
    leadText: {
      EN: "Sunsets in Miyakojima look different depending on where you watch them. Here are five places where you can enjoy ocean sunsets, silhouettes, bridges, and soft evening gradients.",
      中文: "宫古岛的夕阳会因地点不同而呈现不同表情。这里精选5个可以欣赏海上夕阳、岩石剪影、桥与天空渐层的地点。",
      한국어:
        "미야코지마의 석양은 보는 장소에 따라 분위기가 크게 달라집니다. 바다, 실루엣, 다리와 하늘 그라데이션을 즐기기 좋은 5곳입니다.",
    },
    toc: {
      EN: [
        "17END",
        "Sawada Beach",
        "To River Sunset Beach",
        "Painagama Beach",
        "Nagamahama",
      ],
      中文: [
        "17END",
        "佐和田之滨",
        "To River Sunset Beach",
        "Painagama Beach",
        "长间滨",
      ],
      한국어: [
        "17END",
        "사와다노하마",
        "투리버 선셋 비치",
        "파이나가마 비치",
        "나가마하마",
      ],
    },
    points: [
      {
        title: { EN: "17END", 中文: "17END", 한국어: "17END" },
        text: {
          EN: "A scenic Shimoji Island spot where you can see Miyako blue. The view is especially beautiful at low tide, and the colors change slowly before sunset.",
          中文: "可以看到下地岛独有宫古蓝的绝景点。退潮时尤其美，日落前海色与天空颜色会慢慢变化。",
          한국어:
            "시모지섬다운 미야코 블루를 볼 수 있는 절경 스팟입니다. 간조 때 특히 아름답고, 해 질 무렵 바다와 하늘색이 천천히 변합니다.",
        },
      },
      {
        title: {
          EN: "Sawada Beach",
          中文: "佐和田之滨",
          한국어: "사와다노하마",
        },
        text: {
          EN: "A sunset spot on Irabu Island where scattered rocks create beautiful silhouettes.",
          中文: "伊良部岛的夕阳景点，海面岩石与夕阳重叠时剪影非常漂亮。",
          한국어:
            "바다 위의 바위와 석양이 어우러져 아름다운 실루엣을 만드는 이라부섬 선셋 스팟입니다.",
        },
      },
      {
        title: {
          EN: "To River Sunset Beach",
          中文: "To River Sunset Beach",
          한국어: "투리버 선셋 비치",
        },
        text: {
          EN: "Easy to reach from town, this beach is great for an evening walk or a relaxed sunset before dinner.",
          中文: "从市区容易前往，适合傍晚散步或晚餐前轻松看夕阳。",
          한국어:
            "시내에서 접근하기 쉬워 저녁 산책이나 저녁 식사 전 가볍게 석양을 보기 좋습니다.",
        },
      },
      {
        title: {
          EN: "Painagama Beach",
          中文: "Painagama Beach",
          한국어: "파이나가마 비치",
        },
        text: {
          EN: "A convenient sunset spot near town and hotels where you can spend a calm evening by the sea.",
          中文: "靠近市区和酒店，方便前往。适合在海边悠闲度过傍晚。",
          한국어:
            "시내와 호텔에서 가기 쉬운 선셋 스팟으로, 바닷가에서 여유로운 저녁을 보내기 좋습니다.",
        },
      },
      {
        title: { EN: "Nagamahama", 中文: "长间滨", 한국어: "나가마하마" },
        text: {
          EN: "A quiet Kurima Island beach recommended for travelers who want to watch the sunset slowly.",
          中文: "位于来间岛，适合想安静慢慢欣赏夕阳的人。",
          한국어:
            "구리마섬에 있는 조용한 해변으로, 석양을 천천히 바라보고 싶은 분께 추천합니다.",
        },
      },
    ],
  },
  "rainy-day-plan": {
    title: {
      EN: "Indoor Activities to Enjoy on Rainy Days in Miyakojima",
      中文: "宫古岛雨天也能享受的室内体验",
      한국어: "비 오는 날에도 즐길 수 있는 미야코지마 실내 체험",
    },
    text: {
      EN: "Resin art, shisa making, permanent jewelry, and custom accessory workshops for rainy days.",
      中文: "介绍雨天也能体验的树脂艺术、风狮爷制作、永久饰品和定制饰品手作。",
      한국어:
        "비 오는 날에도 즐기기 좋은 레진 아트, 시사 만들기, 퍼머넌트 주얼리, 커스텀 액세서리 체험입니다.",
    },
    description: {
      EN: "A guide to indoor handmade activities in Miyakojima, including resin art, shisa making, permanent jewelry, and custom accessories.",
      中文: "宫古岛室内手作体验指南，包括树脂艺术、风狮爷制作、永久饰品和定制饰品。",
      한국어:
        "레진 아트, 시사 만들기, 퍼머넌트 주얼리, 커스텀 액세서리 등 미야코지마 실내 수공예 체험 가이드입니다.",
    },
    leadText: {
      EN: "If it rains all day during your Miyakojima trip, switching to relaxed indoor handmade activities is a great choice. Resin art, shisa making, permanent jewelry, and custom accessories let you keep travel memories in a tangible form.",
      中文: "宫古岛旅行遇到一整天下雨时，可以改成轻松的室内手作体验。树脂艺术、风狮爷制作、永久饰品和定制饰品，都能把旅途回忆变成实物。",
      한국어:
        "미야코지마 여행 중 하루 종일 비가 오는 날에는 여유로운 실내 수공예 체험으로 바꿔보는 것도 좋습니다. 레진 아트, 시사 만들기, 퍼머넌트 주얼리, 커스텀 액세서리로 여행 추억을 형태로 남길 수 있습니다.",
    },
    toc: {
      EN: [
        "Solve it with a workout",
        "Resin art experience",
        "Shisa making",
        "Accessory making",
      ],
      中文: [
        "健身解决",
        "树脂艺术体验",
        "风狮爷制作",
        "饰品制作",
      ],
      한국어: [
        "근력 운동으로 해결",
        "레진 아트 체험",
        "시사 만들기",
        "액세서리 만들기",
      ],
    },
    points: [
      {
        title: {
          EN: "Solve it with a workout",
          中文: "健身解决",
          한국어: "근력 운동으로 해결",
        },
        text: {
          EN: "On a rainy day, a workout is always a safe bet. Miyakojima has an Anytime Fitness where you can move your body any time, 24 hours a day. With nothing else to do because of the rain, you can actually focus better — it's a real opportunity.",
          中文: "下雨天做健身准没错。宫古岛也有Anytime Fitness健身房，24小时随时都能活动身体。因为下雨没别的事可做，反而能更专注，是个好机会。",
          한국어:
            "비 오는 날에는 근력 운동을 해두면 틀림없습니다. 미야코지마에도 애니타임 피트니스가 있어 24시간 언제든 몸을 움직일 수 있습니다. 비 때문에 딱히 할 일이 없어서 오히려 집중할 수 있는, 좋은 기회입니다.",
        },
        shops: [
          {
            area: { EN: "Miyakojima", 中文: "宫古岛", 한국어: "미야코지마" },
            genre: {
              EN: "Gym / 24-Hour",
              中文: "健身房/24小时营业",
              한국어: "헬스장/24시간 영업",
            },
            text: {
              EN: "A fitness gym chain found across Japan and the world. If rain throws off your plans, switching to a workout is a great way to make good use of your trip time.",
              中文: "在全国乃至全世界展开的连锁健身房。即使因下雨打乱行程，只要切换成健身，也能有效利用旅行时间。",
              한국어:
                "전국・전 세계에 있는 피트니스 체인. 비로 일정이 틀어진 날에도 근력 운동으로 바꾸면 여행 시간을 알차게 쓸 수 있습니다.",
            },
          },
        ],
      },
      {
        title: {
          EN: "Resin art experience",
          中文: "树脂艺术体验",
          한국어: "레진 아트 체험",
        },
        text: {
          EN: "Even when you cannot go into the ocean, Miyakojima memories can still become something you keep. Making ocean-blue resin art is a perfect rainy-day activity.",
          中文: "即使不能下海，也可以把宫古岛旅行回忆变成可以带回家的作品。制作宫古蓝色树脂艺术，很适合雨天。",
          한국어:
            "바다에 들어가지 못하는 날에도 미야코지마의 추억은 간직할 수 있는 작품이 될 수 있습니다. 미야코 블루를 담은 레진 아트는 비 오는 날에 잘 어울립니다.",
        },
        shops: [
          {
            area: { EN: "Irabu Nakachi", 中文: "伊良部仲地", 한국어: "이라부 나카치" },
            genre: {
              EN: "Resin Art / Indoor Experience",
              中文: "树脂艺术/室内体验",
              한국어: "레진 아트/실내 체험",
            },
            recommendedMenu: {
              EN: "Miyakojima Ocean Resin Experience",
              中文: "宫古岛海洋树脂体验",
              한국어: "미야코지마 바다 레진 체험",
            },
            text: {
              EN: "A small tropical atelier where you can enjoy the whole space. Create resin artwork inspired by Miyakojima's ocean, turning your travel memories into something tangible even on a rainy day.",
              中文: "可以享受整个空间氛围的小型南国工作室。制作以宫古岛大海为灵感的树脂作品，即使雨天也能把旅行回忆变成实物。",
              한국어:
                "공간 전체를 즐길 수 있는 작은 남국 아틀리에. 미야코지마의 바다를 이미지화한 레진 작품을 만드는 체험으로, 비 오는 날에도 여행의 추억을 형태로 남길 수 있습니다.",
            },
          },
        ],
      },
      {
        title: {
          EN: "Shisa making",
          中文: "风狮爷制作",
          한국어: "시사 만들기",
        },
        text: {
          EN: "Shisa making is a fun indoor activity when you want a Miyakojima-style keepsake. It is easy to enjoy with family, friends, or as a couple.",
          中文: "想制作具有宫古岛特色的旅行纪念品时，风狮爷制作很适合。家人、朋友、情侣都容易一起体验。",
          한국어:
            "미야코지마다운 여행 기념품을 만들고 싶다면 시사 만들기도 좋습니다. 가족, 친구, 커플 모두 즐기기 쉬운 실내 체험입니다.",
        },
        shops: [
          {
            area: { EN: "Hirara Matsubara", 中文: "平良松原", 한국어: "히라라 마츠바라" },
            genre: {
              EN: "Shisa Making / Indoor Experience",
              中文: "风狮爷制作/室内体验",
              한국어: "시사 만들기/실내 체험",
            },
            recommendedMenu: {
              EN: "Shisa Making Experience",
              中文: "风狮爷制作体验",
              한국어: "시사 만들기 체험",
            },
            text: {
              EN: "An indoor experience spot about 5 minutes by car from Miyako Airport, easy to enjoy even on rainy days. Recommended for making a shisa as a keepsake of your Miyakojima trip.",
              中文: "距宫古机场车程约5分钟，雨天也方便体验的室内景点。推荐制作风狮爷作为宫古岛旅行的纪念。",
              한국어:
                "미야코 공항에서 차로 약 5분 거리에 있어 비 오는 날에도 즐기기 좋은 실내 체험 스팟. 미야코지마 여행 기념으로 시사 만들기를 추천합니다.",
            },
          },
        ],
      },
      {
        title: {
          EN: "Accessory making",
          中文: "饰品制作",
          한국어: "액세서리 만들기",
        },
        text: {
          EN: "Accessory making lets you take the trip home with you. It is great as a Miyakojima souvenir or a small gift.",
          中文: "饰品制作可以把旅行的余韵带回家。很适合作为宫古岛旅行纪念或小礼物。",
          한국어:
            "액세서리 만들기는 여행의 여운을 몸에 지니고 돌아갈 수 있는 체험입니다. 미야코지마 여행 기념이나 선물로도 좋습니다.",
        },
        shops: [
          {
            name: {
              EN: "Churaring (Miyakojima's Original Permanent Jewelry Shop)",
              한국어: "츄라링(미야코지마 원조 퍼머넌트 주얼리 전문점)",
            },
            area: { EN: "Irabu", 中文: "伊良部", 한국어: "이라부" },
            genre: {
              EN: "Permanent Jewelry / Accessories",
              中文: "永久饰品/饰品",
              한국어: "퍼머넌트 주얼리/액세서리",
            },
            recommendedMenu: {
              EN: "Semi-order permanent jewelry",
              中文: "半定制永久饰品",
              한국어: "세미오더 퍼머넌트 주얼리",
            },
            text: {
              EN: "A travel keepsake made to semi-order. Recommended for those who want to wear their Miyakojima memories as an accessory.",
              中文: "半定制打造的旅行纪念。适合想把宫古岛回忆做成饰品随身佩戴的人。",
              한국어:
                "세미오더로 만드는 여행 기념품. 미야코지마의 추억을 액세서리로 몸에 지니고 싶은 분에게 추천합니다.",
            },
          },
          {
            area: { EN: "Irabu", 中文: "伊良部", 한국어: "이라부" },
            genre: {
              EN: "Custom Accessories / Indoor Experience",
              中文: "定制饰品/室内体验",
              한국어: "커스텀 액세서리/실내 체험",
            },
            recommendedMenu: {
              EN: "Tropical custom accessory making",
              中文: "南国定制饰品制作",
              한국어: "남국 커스텀 액세서리 만들기",
            },
            text: {
              EN: "Tropical custom accessories made in Miyakojima. A U15 kids chain option is also available, making it an easy choice for family trips on rainy days.",
              中文: "在宫古岛制作的南国定制饰品。也提供U15儿童专用链条，是雨天亲子旅行也容易选择的体验。",
              한국어:
                "미야코지마에서 만드는 남국 커스텀 액세서리. U15 키즈 전용 체인도 있어 비 오는 날 가족 여행에도 선택하기 좋은 체험입니다.",
            },
          },
        ],
      },
    ],
  },
  "drone-photo-spots": {
    title: {
      EN: "5 Scenic Drone Photo Spots in Miyakojima",
      中文: "宫古岛适合无人机拍摄的5个绝景地点",
      한국어: "미야코지마 드론 촬영 절경 스팟 5선",
    },
    text: {
      EN: "Bridges, beaches, sunsets, and Miyako blue views that look beautiful from above.",
      中文: "从空中拍摄很好看的桥、海滩、夕阳和宫古蓝绝景。",
      한국어:
        "하늘에서 보면 아름다운 다리, 해변, 석양, 미야코 블루 절경입니다.",
    },
    description: {
      EN: "Five Miyakojima spots that look beautiful in drone photos and videos.",
      中文: "精选宫古岛适合无人机照片和视频拍摄的5个地点。",
      한국어:
        "드론 사진과 영상으로 아름답게 남기기 좋은 미야코지마 스팟 5곳입니다.",
    },
    leadText: {
      EN: "Miyakojima is beautiful from the ground, but drone views reveal even more of the ocean gradients and island shapes. Here are spots that are especially worth capturing from above.",
      中文: "宫古岛从地面看已经很美，但用无人机从空中看，海色渐层和地形魅力会更明显。这里整理了适合空拍记录的地点。",
      한국어:
        "미야코지마의 바다는 지상에서 봐도 아름답지만, 드론으로 위에서 보면 바다 그라데이션과 지형의 매력이 더 잘 전해집니다. 하늘에서 남기고 싶은 스팟을 정리했습니다.",
    },
    toc: {
      EN: [
        "Irabu Bridge",
        "17END",
        "Yonaha Maehama",
        "Sawada Beach",
        "Kurima Bridge",
      ],
      中文: ["伊良部大桥", "17END", "与那霸前滨", "佐和田之滨", "来间大桥"],
      한국어: [
        "이라부대교",
        "17END",
        "요나하 마에하마",
        "사와다노하마",
        "쿠리마대교",
      ],
    },
    cta: {
      title: {
        EN: "Drone Shooting on a Scenic Photo Tour",
        中文: "绝景行程中的无人机拍摄",
        한국어: "절경 투어에서 드론 촬영",
      },
      text: {
        EN: "Visit scenic Miyakojima spots and keep your travel memories with drone and camera photos.",
        中文: "巡游宫古岛绝景地点，用无人机和相机为旅途留下回忆。",
        한국어:
          "미야코지마 절경 스팟을 돌며 드론과 카메라 촬영으로 여행의 추억을 남깁니다.",
      },
      buttonText: {
        EN: "Book Scenic Photo Tour",
        中文: "预约绝景摄影行程",
        한국어: "절경 촬영 투어 예약",
      },
    },
    points: [
      {
        title: { EN: "Irabu Bridge", 中文: "伊良部大桥", 한국어: "이라부대교" },
        text: {
          EN: "A spot where the scale of Miyakojima's bridge and ocean is easy to capture. Check rules and shoot from safe, permitted locations.",
          中文: "很容易拍出宫古岛大桥与大海规模感的地点。请确认规则，从安全且允许拍摄的位置拍摄。",
          한국어:
            "미야코지마다운 다리와 바다의 스케일을 남기기 쉬운 스팟입니다. 안전과 규칙을 확인하고 촬영 가능한 장소에서 무리 없이 촬영하세요.",
        },
      },
      {
        title: { EN: "17END", 中文: "17END", 한국어: "17END" },
        text: {
          EN: "A famous Shimoji Island spot where shallow water creates beautiful blue gradients, especially at low tide and on sunny days.",
          中文: "下地岛人气地点，远浅海面会呈现美丽蓝色渐层，退潮和晴天时尤其漂亮。",
          한국어:
            "얕은 바다 색이 잘 드러나는 시모지섬 인기 스팟입니다. 간조와 맑은 시간대에는 미야코 블루 그라데이션이 특히 아름답습니다.",
        },
      },
      {
        title: {
          EN: "Yonaha Maehama",
          中文: "与那霸前滨",
          한국어: "요나하 마에하마",
        },
        text: {
          EN: "The contrast of white sand and blue water is beautiful. When it is crowded, be considerate and use wide compositions.",
          中文: "白沙和蓝海的对比非常美。人多时请注意周围，用宽广构图拍摄。",
          한국어:
            "하얀 모래와 바다의 대비가 아름다운 해변입니다. 사람이 많은 시간에는 주변을 배려하며 넓은 모래사장과 바다를 크게 담는 구도가 좋습니다.",
        },
      },
      {
        title: {
          EN: "Sawada Beach",
          中文: "佐和田之滨",
          한국어: "사와다노하마",
        },
        text: {
          EN: "Scattered rocks and sunset light create a quiet Miyakojima mood. Shoot before it gets too dark.",
          中文: "点缀在海面的岩石与夕阳氛围很有宫古岛的宁静感。建议天色太暗前拍摄。",
          한국어:
            "점점이 떠 있는 바위와 석양 분위기가 인상적인 곳입니다. 너무 어두워지기 전에 촬영하는 것이 좋습니다.",
        },
      },
      {
        title: { EN: "Kurima Bridge", 中文: "来间大桥", 한국어: "쿠리마대교" },
        text: {
          EN: "A beautiful area where the bridge to Kurima Island and the ocean colors line up nicely. Easy to add to a drive route.",
          中文: "通往来间岛的大桥与海色非常漂亮。自驾途中也很容易顺路停留。",
          한국어:
            "쿠리마섬으로 향하는 다리와 바다 색이 아름다운 지역입니다. 드라이브 흐름 속에서 들르기 쉽습니다.",
        },
      },
    ],
  },
  "jet-secret-beach-tour": {
    title: {
      EN: "A Private Jet Ski Tour to the Real Hidden Miyakojima",
      中文: "乘坐摩托艇前往真正宫古岛秘境的私人行程",
      한국어: "제트스키로 만나는 진짜 미야코지마 비밀 투어",
    },
    text: {
      EN: "A private tour to Yuni Beach and secret beaches reachable only by jet ski, with drone shooting included.",
      中文: "前往幻之滨和摩托艇才能抵达的秘境海滩，含无人机拍摄的私人行程。",
      한국어:
        "유니노하마와 제트스키로만 갈 수 있는 시크릿 비치를 도는 드론 촬영 포함 프라이빗 투어입니다.",
    },
    description: {
      EN: "Discover hidden Miyakojima by jet ski. Visit Yuni Beach and secret beaches on a private tour with drone shooting.",
      中文: "乘坐摩托艇探索宫古岛秘境。私人前往幻之滨与秘境海滩，并包含无人机拍摄。",
      한국어:
        "제트스키로 미야코지마의 숨은 바다를 만나는 프라이빗 투어. 유니노하마와 시크릿 비치, 드론 촬영이 포함됩니다.",
    },
    leadText: {
      EN: "Miyakojima hides special views that can only be reached on a tour. Ride across quiet blue water by jet ski to Yuni Beach and secret beaches, enjoy Miyako blue in complete privacy, and keep the memory with drone footage.",
      中文: "宫古岛藏着只有参加行程才能抵达的特别景色。乘坐摩托艇穿过安静的海面，前往幻之滨与秘境海滩，完全私人地享受宫古蓝，并用无人机留下旅途回忆。",
      한국어:
        "미야코지마에는 투어로만 갈 수 있는 특별한 풍경이 숨어 있습니다. 제트스키로 조용한 바다를 달려 유니노하마와 시크릿 비치로 향하고, 프라이빗하게 미야코 블루를 즐기며 드론 영상으로 추억을 남깁니다.",
    },
    youtubeTitle: {
      EN: "Yuni Beach and Secret Beach Jet Ski Tour",
      中文: "幻之滨与秘境海滩摩托艇行程",
      한국어: "유니노하마・시크릿 비치 제트스키 투어",
    },
    toc: {
      EN: [
        "Reason 1: Reach hidden beaches only accessible by jet ski",
        "Reason 2: Visit Yuni Beach and secret beaches",
        "Reason 3: Keep the scenery with drone shooting",
      ],
      中文: [
        "理由1：前往摩托艇才能抵达的秘境",
        "理由2：巡游幻之滨与秘境海滩",
        "理由3：用无人机留下绝景",
      ],
      한국어: [
        "이유 1: 제트스키로만 갈 수 있는 비밀 해변",
        "이유 2: 유니노하마와 시크릿 비치",
        "이유 3: 드론 촬영으로 절경을 남기기",
      ],
    },
    cta: {
      title: {
        EN: "Yuni Beach and Secret Beach Jet Ski Tour",
        中文: "幻之滨・秘境海滩摩托艇行程",
        한국어: "유니노하마・시크릿 비치 제트스키 투어",
      },
      text: {
        EN: "A private tour for one group only, visiting clear Miyakojima waters and hidden beaches reachable only by jet ski.",
        中文: "一组限定的完全私人行程，带您前往透明度极高的宫古岛海域和摩托艇才能抵达的秘境。",
        한국어:
          "1팀 한정 프라이빗 투어로, 투명한 미야코지마 바다와 제트스키로만 갈 수 있는 비밀 해변으로 안내합니다.",
      },
      buttonText: {
        EN: "View Jet Ski Tour",
        中文: "查看摩托艇行程",
        한국어: "제트스키 투어 보기",
      },
    },
    points: [
      {
        title: {
          EN: "Reason 1: Reach hidden beaches only accessible by jet ski",
          中文: "理由1：前往摩托艇才能抵达的秘境",
          한국어: "이유 1: 제트스키로만 갈 수 있는 비밀 해변",
        },
        text: {
          EN: "Miyakojima has places that cannot be reached by car or on foot. A jet ski lets you enter areas accessible only from the sea, giving you a side of Miyakojima that ordinary sightseeing cannot show.",
          中文: "宫古岛有些地方无法开车或步行抵达。乘坐摩托艇可以从海上进入这些区域，体验普通观光看不到的宫古岛。",
          한국어:
            "미야코지마에는 차나 도보로는 갈 수 없는 비밀 장소가 있습니다. 제트스키라면 바다에서만 들어갈 수 있는 지역으로 향할 수 있어 일반 관광과는 다른 미야코지마를 경험할 수 있습니다.",
        },
        rows: [
          [
            { EN: "Experience", 中文: "体验", 한국어: "체험" },
            {
              EN: "Secret beaches by jet ski",
              中文: "乘摩托艇前往秘境海滩",
              한국어: "제트스키로 시크릿 비치 이동",
            },
          ],
          [
            { EN: "Mood", 中文: "氛围", 한국어: "분위기" },
            {
              EN: "Quiet beaches with few tourists",
              中文: "游客很少的安静海滩",
              한국어: "관광객이 적은 조용한 해변",
            },
          ],
          [
            { EN: "Recommended", 中文: "推荐", 한국어: "추천" },
            {
              EN: "For travelers who want a special time on a quiet ocean",
              中文: "适合想在安静海域度过特别时间的人",
              한국어: "사람이 적은 바다에서 특별한 시간을 보내고 싶은 분",
            },
          ],
        ],
      },
      {
        title: {
          EN: "Reason 2: Visit Yuni Beach and secret beaches",
          中文: "理由2：巡游幻之滨与秘境海滩",
          한국어: "이유 2: 유니노하마와 시크릿 비치",
        },
        text: {
          EN: "In addition to Yuni Beach, the tour visits secret beaches selected according to the sea conditions of the day. Multiple spots make the short tour feel full.",
          中文: "除了幻之滨，还会根据当天海况前往摩托艇才能抵达的秘境海滩。短时间内巡游多个地点，满足感很高。",
          한국어:
            "유니노하마에 더해 당일 해황에 맞춰 제트스키로만 갈 수 있는 시크릿 비치로 안내합니다. 여러 스팟을 돌아 짧은 시간에도 만족감이 큽니다.",
        },
        rows: [
          [
            { EN: "Destination", 中文: "目的地", 한국어: "목적지" },
            {
              EN: "Yuni Beach / hidden secret beaches",
              中文: "幻之滨 / 秘境・秘密海滩",
              한국어: "유니노하마 / 비밀 시크릿 비치",
            },
          ],
          [
            { EN: "Duration", 中文: "所需时间", 한국어: "소요 시간" },
            {
              EN: "About 2.5 hours, excluding pickup and drop-off time",
              中文: "约2.5小时，不含接送时间",
              한국어: "약 2.5시간, 픽업・송영 시간 제외",
            },
          ],
          [
            { EN: "Price", 中文: "价格", 한국어: "요금" },
            {
              EN: "¥35,000 / person",
              中文: "¥35,000 / 1人",
              한국어: "¥35,000 / 1명",
            },
          ],
        ],
      },
      {
        title: {
          EN: "Reason 3: Keep the scenery with drone shooting",
          中文: "理由3：用无人机留下绝景",
          한국어: "이유 3: 드론 촬영으로 절경을 남기기",
        },
        text: {
          EN: "Photos in a private hidden beach with no crowds are perfect for social media. After the tour, you receive both iPhone footage and drone data.",
          中文: "在无人打扰的私人秘境拍摄，SNS氛围感很强。行程结束后会交付iPhone拍摄数据和无人机数据。",
          한국어:
            "사람이 없는 프라이빗 비밀 해변에서의 촬영은 SNS에도 잘 어울립니다. 투어 종료 후 iPhone 촬영 데이터와 드론 데이터를 전달합니다.",
        },
        rows: [
          [
            { EN: "Shooting", 中文: "拍摄", 한국어: "촬영" },
            {
              EN: "Drone shooting included",
              中文: "包含无人机拍摄",
              한국어: "드론 촬영 포함",
            },
          ],
          [
            { EN: "Data", 中文: "数据", 한국어: "데이터" },
            {
              EN: "iPhone footage / drone data",
              中文: "iPhone拍摄数据 / 无人机数据",
              한국어: "iPhone 촬영 데이터 / 드론 데이터",
            },
          ],
          [
            { EN: "Recommended", 中文: "推荐", 한국어: "추천" },
            {
              EN: "Travel memories / social media posts / short videos",
              中文: "旅行回忆 / SNS投稿 / 短视频",
              한국어: "여행 추억 / SNS投稿 / 쇼트 영상",
            },
          ],
        ],
      },
    ],
  },
  "miyakojima-surfing": {
    title: {
      EN: "3 Reasons to Try Surfing in Miyakojima",
      中文: "在宫古岛体验冲浪的3个理由",
      한국어: "미야코지마에서 서핑해야 하는 3가지 이유",
    },
    text: {
      EN: "Quiet water, Miyako blue scenery, and a safe local guide make surfing special here.",
      中文: "人少的海、宫古蓝的景色和本地向导，让这里的冲浪体验更加特别。",
      한국어:
        "한적한 바다, 미야코 블루 풍경, 로컬 가이드가 있어 특별한 서핑 체험입니다.",
    },
    description: {
      EN: "Three reasons to surf in Miyakojima: quiet ocean, beautiful Miyako blue, and beginner-friendly local guidance.",
      中文: "总结在宫古岛冲浪的3个理由：人少的海、宫古蓝体验、本地向导带来的安心感。",
      한국어:
        "한적한 바다, 미야코 블루, 초보자도 안심할 수 있는 로컬 가이드까지 미야코지마 서핑의 매력을 소개합니다.",
    },
    leadText: {
      EN: "Miyakojima is often known for snorkeling and SUP, but surfing is also possible here. Because it is still not widely known, you can face the waves in a quieter ocean. Here are three reasons to try surfing in Miyakojima.",
      中文: "说到宫古岛，很多人会想到浮潜和SUP，但其实这里也可以冲浪。因为还不太为人所知，所以能在较少人的海上慢慢面对海浪。这里介绍在宫古岛冲浪的3个理由。",
      한국어:
        "미야코지마는 스노클링과 SUP 이미지가 강하지만 사실 서핑도 즐길 수 있습니다. 아직 잘 알려지지 않아 한적한 바다에서 파도를 마주할 수 있다는 점이 큰 매력입니다.",
    },
    youtubeTitle: {
      EN: "Miyakojima Surfing Experience",
      中文: "宫古岛冲浪体验氛围",
      한국어: "미야코지마 서핑 체험 분위기",
    },
    guideInstagram: {
      title: {
        EN: "Guide Instagram",
        中文: "向导Instagram",
        한국어: "가이드 Instagram",
      },
      text: {
        EN: "Check the ocean conditions and surfing atmosphere here.",
        中文: "可以在这里查看当天海况和冲浪氛围。",
        한국어: "당일 바다 분위기와 서핑 모습을 여기에서 확인할 수 있습니다.",
      },
      cta: {
        EN: "View Instagram",
        中文: "查看Instagram",
        한국어: "Instagram 보기",
      },
    },
    toc: {
      EN: [
        "Reason 1: Beginner-friendly with a local guide",
        "Reason 2: Enjoy a quieter ocean",
        "Reason 3: Capture photos and videos in Miyako blue water",
      ],
      中文: [
        "理由1：本地向导陪同，初学者也容易挑战",
        "理由2：在人少的海里慢慢享受",
        "理由3：在宫古蓝海中留下特别照片和视频",
      ],
      한국어: [
        "이유 1: 로컬 가이드와 함께 초보자도 도전하기 쉬움",
        "이유 2: 한적한 바다에서 여유롭게 즐김",
        "이유 3: 미야코 블루 바다에서 특별한 사진과 영상 남기기",
      ],
    },
    cta: {
      title: {
        EN: "Surfing in Miyakojima's Blue Ocean",
        中文: "在宫古岛蓝色海中体验冲浪",
        한국어: "미야코지마 푸른 바다에서 서핑 체험",
      },
      text: {
        EN: "A local guide chooses the point according to the day's ocean conditions. Come empty-handed, with an optional drone shooting add-on.",
        中文: "本地向导会根据当天海况选择冲浪点。可手ぶら参加，也能追加无人机拍摄选项。",
        한국어:
          "로컬 출신 가이드가 당일 해황에 맞춰 포인트로 안내합니다. 빈손 참여 가능하며 드론 촬영 옵션도 추가할 수 있습니다.",
      },
      buttonText: {
        EN: "View Surfing Tour",
        中文: "查看冲浪体验",
        한국어: "서핑 체험 보기",
      },
    },
    points: [
      {
        title: {
          EN: "Reason 1: Beginner-friendly with a local guide",
          中文: "理由1：本地向导陪同，初学者也容易挑战",
          한국어: "이유 1: 로컬 가이드와 함께 초보자도 도전하기 쉬움",
        },
        text: {
          EN: "Miyakojima's ocean is beautiful, but reefs and currents require care. A local guide checks wind, waves, and tide, then takes you to a safer point. Board rental, reef boots, and lesson fees are included, so you can join empty-handed.",
          中文: "宫古岛的海很美，但礁石和潮流也需要注意。本地向导会根据当天风、浪和潮位，带您前往更安全的地点。冲浪板、礁石靴和课程费用都包含在内，可轻松参加。",
          한국어:
            "미야코지마의 바다는 아름답지만 리프와 조류 등 주의가 필요합니다. 로컬 가이드가 그날의 바람, 파도, 조위를 보고 안전하게 즐길 수 있는 포인트로 안내합니다. 보드와 리프부츠 렌탈, 레슨비가 포함되어 빈손으로 참여할 수 있습니다.",
        },
        rows: [
          [
            { EN: "Price", 中文: "价格", 한국어: "요금" },
            {
              EN: "¥15,000 / person",
              中文: "¥15,000 / 1人",
              한국어: "¥15,000 / 1명",
            },
          ],
          [
            { EN: "Included", 中文: "包含", 한국어: "포함 사항" },
            {
              EN: "Lesson / surfboard / reef boots",
              中文: "课程费 / 冲浪板 / 礁石靴",
              한국어: "레슨비 / 서프보드 / 리프부츠",
            },
          ],
          [
            { EN: "Meeting", 中文: "集合", 한국어: "집합" },
            {
              EN: "Meet on site / location shared in advance",
              中文: "当地集合 / 集合地点会事前通知",
              한국어: "현지 집합 / 집합 장소는 사전 안내",
            },
          ],
        ],
      },
      {
        title: {
          EN: "Reason 2: Enjoy a quieter ocean",
          中文: "理由2：在人少的海里慢慢享受",
          한국어: "이유 2: 한적한 바다에서 여유롭게 즐김",
        },
        text: {
          EN: "Surfing in Miyakojima is still not widely known, so the ocean is often less crowded than famous surf spots. Beginners can relax and focus on the waves.",
          中文: "宫古岛可以冲浪这件事还不太为人所知，所以相比知名冲浪点，海面更不容易拥挤。初学者也能更放松地面对海浪。",
          한국어:
            "미야코지마에서 서핑할 수 있다는 사실은 아직 많이 알려져 있지 않습니다. 그래서 유명 서핑 스팟보다 바다가 덜 붐비고, 초보자도 주변을 신경 쓰지 않고 파도에 집중하기 쉽습니다.",
        },
        rows: [
          [
            { EN: "Recommended", 中文: "推荐", 한국어: "추천" },
            {
              EN: "Beginners / morning activity / travel experience",
              中文: "初学者 / 早晨活动 / 旅行中的体验",
              한국어: "초보자 / 아침 액티비티 / 여행 중 체험",
            },
          ],
          [
            { EN: "Appeal", 中文: "魅力", 한국어: "매력" },
            {
              EN: "Practice slowly in a quieter ocean",
              中文: "在人少的海里慢慢练习",
              한국어: "사람이 적은 바다에서 천천히 연습 가능",
            },
          ],
          [
            { EN: "Time", 中文: "时间", 한국어: "시간" },
            {
              EN: "Starts around 7:00 / about 3 hours",
              中文: "约7:00开始 / 约3小时",
              한국어: "7:00경 시작 / 약 3시간",
            },
          ],
        ],
      },
      {
        title: {
          EN: "Reason 3: Capture photos and videos in Miyako blue water",
          中文: "理由3：在宫古蓝海中留下特别照片和视频",
          한국어: "이유 3: 미야코 블루 바다에서 특별한 사진과 영상 남기기",
        },
        text: {
          EN: "Surfing in Miyakojima's clear blue water already feels special. Add drone shooting to capture the moment you ride a wave and the color of the ocean.",
          中文: "在透明度高的宫古岛海中冲浪，本身就是特别回忆。追加无人机拍摄后，可以把乘浪瞬间和海色都留下。",
          한국어:
            "투명도 높은 미야코지마 바다에서 서핑하는 것만으로도 특별한 추억이 됩니다. 드론 촬영을 추가하면 파도를 타는 순간과 바다색까지 사진과 영상으로 남길 수 있습니다.",
        },
        rows: [
          [
            { EN: "Shooting option", 中文: "拍摄选项", 한국어: "촬영 옵션" },
            {
              EN: "Drone shooting +¥10,000 / group, +¥16,000 for 4 or more people",
              中文: "无人机拍摄 +¥10,000 / 组，4人以上 +¥16,000",
              한국어: "드론 촬영 +¥10,000 / 그룹, 4명 이상 +¥16,000",
            },
          ],
          [
            { EN: "Delivery", 中文: "交付", 한국어: "전달" },
            {
              EN: "Delivered by AirDrop after the lesson",
              中文: "课程结束后通过AirDrop交付",
              한국어: "레슨 종료 후 AirDrop으로 전달",
            },
          ],
          [
            { EN: "Recommended", 中文: "推荐", 한국어: "추천" },
            {
              EN: "Travel memories / social media posts / short videos",
              中文: "旅行回忆 / SNS投稿 / 短视频",
              한국어: "여행 추억 / SNS投稿 / 쇼트 영상",
            },
          ],
        ],
      },
    ],
  },
  "miyakojima-surfing-experience": {
    title: {
      EN: "What the Miyakojima Surfing Experience Looks Like",
      中文: "宫古岛冲浪体验实况",
      한국어: "미야코지마 서핑 체험 모습",
    },
    text: {
      EN: "See the morning ocean, lesson, wave-riding moments, and photo/video delivery through real footage and photos.",
      中文: "通过实际视频和照片，了解清晨大海、课程、乘浪瞬间以及照片・视频交付的流程。",
      한국어:
        "아침 바다, 레슨, 파도를 타는 순간, 사진・영상 전달까지 실제 영상과 사진으로 소개합니다.",
    },
    description: {
      EN: "A visual guide to the Miyakojima surfing experience, with real videos and photos showing the ocean, lesson flow, and photo/video delivery.",
      中文: "用实际视频和照片介绍宫古岛冲浪体验的氛围，包括海况、课程流程和照片・视频交付。",
      한국어:
        "실제 영상과 사진으로 미야코지마 서핑 체험의 분위기, 레슨 흐름, 사진・영상 전달까지 보여주는 글입니다.",
    },
    leadText: {
      EN: "Surfing in Miyakojima is still not widely known. Clear water, quieter points, and support from a local guide make it a special morning activity even for beginners. This article shows the experience through real photos and videos.",
      中文: "宫古岛可以冲浪这件事还不太为人所知。透明度高的海、人少的地点和本地向导的支持，让初学者也能拥有特别的清晨体验。本文用实际照片和视频介绍体验氛围。",
      한국어:
        "미야코지마에서 서핑할 수 있다는 사실은 아직 많이 알려져 있지 않습니다. 투명한 바다, 한적한 포인트, 로컬 가이드의 지원이 있어 초보자에게도 특별한 아침 체험이 됩니다.",
    },
    toc: {
      EN: [
        "Meet on site by the morning ocean",
        "Try surfing safely with a local guide lesson",
        "Keep the surfing memory with photos and videos",
        "Enjoy the experience with multilingual guide support",
      ],
      中文: [
        "清晨海边现场集合",
        "本地向导课程，安心挑战冲浪",
        "用照片和视频留下冲浪回忆",
        "多语言向导支持，轻松享受体验",
      ],
      한국어: [
        "아침 바다에서 현지 집합",
        "로컬 가이드 레슨으로 안심하고 도전",
        "사진과 영상으로 서핑 추억 남기기",
        "다국어 가이드 서포트로 편하게 즐기기",
      ],
    },
    cta: {
      title: {
        EN: "Try Surfing in Miyakojima",
        中文: "在宫古岛体验冲浪",
        한국어: "미야코지마에서 서핑 체험",
      },
      text: {
        EN: "Surfboard, reef boots, and lesson fee are included. A local guide checks the ocean conditions and takes you to a safer point.",
        中文: "包含冲浪板、礁石靴和课程费用。本地向导会根据海况带您前往更安全的地点。",
        한국어:
          "서프보드, 리프부츠, 레슨비가 포함되어 있습니다. 로컬 가이드가 해황을 보고 안전하게 즐길 수 있는 포인트로 안내합니다.",
      },
      buttonText: {
        EN: "View Surfing Tour",
        中文: "查看冲浪体验",
        한국어: "서핑 체험 보기",
      },
    },
    points: [
      {
        title: {
          EN: "Meet on site by the morning ocean",
          中文: "清晨海边现场集合",
          한국어: "아침 바다에서 현지 집합",
        },
        text: {
          EN: "The surfing experience starts around 7:00 in the morning. The meeting location is shared in advance after checking the wind, waves, and tide for the day.",
          中文: "冲浪体验约早上7点开始。集合地点会根据当天风、浪和潮位提前告知。",
          한국어:
            "서핑 체험은 아침 7시경 시작합니다. 집합 장소는 그날의 바람, 파도, 조위를 확인한 뒤 사전에 안내드립니다.",
        },
        rows: [
          [
            { EN: "Meeting", 中文: "集合", 한국어: "집합" },
            {
              EN: "Meet on site / location shared in advance",
              中文: "现场集合 / 集合地点事前通知",
              한국어: "현지 집합 / 장소는 사전 안내",
            },
          ],
          [
            { EN: "Start time", 中文: "开始时间", 한국어: "시작 시간" },
            { EN: "Around 7:00", 中文: "约7:00", 한국어: "7:00경" },
          ],
          [
            { EN: "Duration", 中文: "所需时间", 한국어: "소요 시간" },
            { EN: "About 3 hours", 中文: "约3小时", 한국어: "약 3시간" },
          ],
        ],
      },
      {
        title: {
          EN: "Try surfing safely with a local guide lesson",
          中文: "本地向导课程，安心挑战冲浪",
          한국어: "로컬 가이드 레슨으로 안심하고 도전",
        },
        text: {
          EN: "Miyakojima's ocean is beautiful, but reefs and currents require care. A local guide gives safety guidance and a basic lesson, then supports you according to the day's conditions.",
          中文: "宫古岛的海很美，但礁石和潮流也需要注意。本地向导会进行安全说明和基础课程，并根据当天状况提供支持。",
          한국어:
            "미야코지마의 바다는 아름답지만 리프와 조류 등 주의가 필요합니다. 로컬 가이드가 안전 설명과 기본 레슨을 진행하고, 당일 컨디션에 맞춰 서포트합니다.",
        },
        rows: [
          [
            { EN: "Included", 中文: "包含", 한국어: "포함 사항" },
            {
              EN: "Lesson / surfboard / reef boots",
              中文: "课程 / 冲浪板 / 礁石靴",
              한국어: "레슨 / 서프보드 / 리프부츠",
            },
          ],
          [
            { EN: "Level", 中文: "对象", 한국어: "대상" },
            { EN: "Beginners OK", 中文: "初学者OK", 한국어: "초보자 OK" },
          ],
          [
            { EN: "Price", 中文: "价格", 한국어: "요금" },
            {
              EN: "¥15,000 / person",
              中文: "¥15,000 / 1人",
              한국어: "¥15,000 / 1명",
            },
          ],
        ],
      },
      {
        title: {
          EN: "Keep the surfing memory with photos and videos",
          中文: "用照片和视频留下冲浪回忆",
          한국어: "사진과 영상으로 서핑 추억 남기기",
        },
        text: {
          EN: "It is hard to capture yourself in the ocean while traveling. Add the shooting option to receive photos and videos after the experience.",
          中文: "旅行中很难自己拍下在海里冲浪的样子。追加拍摄选项后，体验结束后可收到照片和视频数据。",
          한국어:
            "여행 중 바다에 들어간 모습이나 파도를 타는 순간을 직접 남기기는 어렵습니다. 촬영 옵션을 추가하면 체험 후 사진과 영상 데이터를 받을 수 있습니다.",
        },
        rows: [
          [
            { EN: "Shooting option", 中文: "拍摄选项", 한국어: "촬영 옵션" },
            {
              EN: "Drone shooting +¥10,000 / group",
              中文: "无人机拍摄 +¥10,000 / 组",
              한국어: "드론 촬영 +¥10,000 / 그룹",
            },
          ],
          [
            { EN: "4 or more people", 中文: "4人以上", 한국어: "4명 이상" },
            {
              EN: "Drone shooting +¥16,000",
              中文: "无人机拍摄 +¥16,000",
              한국어: "드론 촬영 +¥16,000",
            },
          ],
          [
            { EN: "Delivery", 中文: "交付", 한국어: "전달" },
            {
              EN: "Photo and video data after the experience",
              中文: "体验后交付照片・视频数据",
              한국어: "체험 후 사진・영상 데이터 전달",
            },
          ],
        ],
      },
      {
        title: {
          EN: "Enjoy the experience with multilingual guide support",
          中文: "多语言向导支持，轻松享受体验",
          한국어: "다국어 가이드 서포트로 편하게 즐기기",
        },
        text: {
          EN: "Even if you speak a different language, the joy of being in the ocean comes through naturally. An experienced local guide who has welcomed many international guests will support you with simple English, gestures, and clear guidance so you can enjoy surfing beyond the language barrier.",
          中文: "即使语言不同，只要进入大海，快乐也会自然传递。经验丰富的本地向导曾接待过许多海外游客，会用简单英语、手势和清晰说明进行支持，让您跨越语言障碍享受宫古岛冲浪。",
          한국어:
            "언어가 달라도 바다에 들어가면 즐거움은 자연스럽게 전해집니다. 많은 해외 게스트를 안내해 온 경험 많은 로컬 가이드가 간단한 영어, 제스처, 쉬운 설명으로 서포트해 언어의 장벽을 넘어 서핑을 즐길 수 있습니다.",
        },
        rows: [
          [
            { EN: "Support", 中文: "支持", 한국어: "지원" },
            {
              EN: "Japanese / simple English / gestures",
              中文: "日语 / 简单英语 / 手势支持",
              한국어: "일본어 / 간단한 영어 / 제스처",
            },
          ],
          [
            { EN: "Guide", 中文: "向导", 한국어: "가이드" },
            {
              EN: "Experienced local guide for international guests",
              中文: "拥有海外游客接待经验的本地向导",
              한국어: "해외 게스트 안내 경험이 풍부한 로컬 가이드",
            },
          ],
          [
            { EN: "Good for", 中文: "适合", 한국어: "추천" },
            {
              EN: "Guests who feel unsure about language",
              中文: "对语言沟通感到不安的游客",
              한국어: "언어가 걱정되는 게스트",
            },
          ],
        ],
      },
    ],
  },
  "miyakojima-surfing-guide": {
    title: {
      EN: "If You Come to Miyakojima, You Have to Try Surfing!",
      中文: "来宫古岛一定要试试冲浪！",
      한국어: "미야코지마에 왔다면 서핑은 꼭 해봐야 해요!",
    },
    text: {
      EN: "Sunrise, beginner lessons, multilingual support, and the confidence of a local guide. A video guide to surfing in Miyakojima.",
      中文: "从日出、初学者课程、多语言支持到本地向导的安心感，用视频介绍宫古岛冲浪体验。",
      한국어:
        "선라이즈, 초보자 레슨, 다국어 지원, 로컬 가이드의 든든함까지 영상으로 소개하는 미야코지마 서핑 체험입니다.",
    },
    description: {
      EN: "A guide for anyone who wants to surf in Miyakojima, featuring clear ocean waves, sunrise from the sea, beginner-friendly lessons, multilingual support, and a veteran local guide.",
      中文: "写给想在宫古岛冲浪的人。介绍透明度高的大海、海上日出、适合初学者的课程、多语言支持和经验丰富的本地向导。",
      한국어:
        "미야코지마에서 서핑하고 싶은 분들을 위한 가이드입니다. 투명한 바다, 바다 위 선라이즈, 초보자 레슨, 다국어 지원, 베테랑 로컬 가이드를 소개합니다.",
    },
    leadText: {
      EN: "Not many people know that Miyakojima is also a great place to surf. Riding waves in the quiet morning ocean with a local guide is a special experience you do not get from ordinary sightseeing. Beginners are welcome, and the guide chooses the best point for the day's wind, waves, and tide.",
      中文: "很多人还不知道宫古岛也可以冲浪。在清晨人少的海上，与本地向导一起乘浪，是普通观光无法体验的特别时光。初学者也可以安心参加，向导会根据当天的风、浪和潮位选择最佳地点。",
      한국어:
        "미야코지마에서 서핑을 할 수 있다는 사실은 아직 많이 알려져 있지 않습니다. 아침의 조용한 바다에서 로컬 가이드와 함께 파도를 타는 시간은 일반 관광에서는 느낄 수 없는 특별한 경험입니다. 초보자도 안심할 수 있도록 그날의 바람, 파도, 조위에 맞춰 가장 좋은 포인트로 안내합니다.",
    },
    toc: {
      EN: [
        "Ride waves in crystal-clear water, an experience you cannot get anywhere else",
        "Multilingual support",
        "Beginner-friendly surfing lessons",
        "Meet the guide",
      ],
      中文: [
        "在透明度极高的海上乘浪，其他地方难以体验",
        "多语言支持",
        "初学者也安心的冲浪课程",
        "向导介绍",
      ],
      한국어: [
        "투명도 높은 바다에서 파도를 타는 특별한 경험",
        "다국어 지원",
        "초보자도 안심할 수 있는 서핑 레슨",
        "가이드 소개",
      ],
    },
    cta: {
      title: {
        EN: "Try Surfing in Miyakojima",
        中文: "在宫古岛体验冲浪",
        한국어: "미야코지마에서 서핑 체험",
      },
      text: {
        EN: "A local guide checks the wind, waves, and tide, then takes you to a safer point for the day. Surfboard, reef boots, and lesson fee are included, so you can join hands-free.",
        中文: "本地向导会根据当天的风、浪和潮位，带您前往更安全的地点。冲浪板、礁石靴和课程费用都包含在内，轻装即可参加。",
        한국어:
          "로컬 가이드가 그날의 바람, 파도, 조위를 확인하고 안전하게 즐길 수 있는 포인트로 안내합니다. 서프보드, 리프부츠, 레슨비가 포함되어 있어 빈손으로 참가할 수 있습니다.",
      },
      buttonText: {
        EN: "View Surfing Tour",
        中文: "查看冲浪体验",
        한국어: "서핑 체험 보기",
      },
    },
    guideInstagram: {
      title: {
        EN: "Meet the Guide",
        中文: "向导介绍",
        한국어: "가이드 소개",
      },
      text: {
        EN: "A veteran local guide who knows Miyakojima's waves takes you to the best spot of the day. Beginners can enjoy the experience with confidence.",
        中文: "熟悉宫古岛海浪的资深本地向导，会带您前往当天最佳地点。初学者也可以安心享受。",
        한국어:
          "미야코지마의 파도를 잘 아는 베테랑 로컬 가이드가 그날 가장 좋은 장소로 안내합니다. 초보자도 안심하고 즐길 수 있습니다.",
      },
      cta: {
        EN: "View Instagram",
        中文: "查看Instagram",
        한국어: "Instagram 보기",
      },
    },
    points: [
      {
        title: {
          EN: "Ride waves in crystal-clear water, an experience you cannot get anywhere else",
          中文: "在透明度极高的海上乘浪，其他地方难以体验",
          한국어: "투명도 높은 바다에서 파도를 타는 특별한 경험",
        },
        area: {
          EN: "Sunrise Surf",
          中文: "日出冲浪",
          한국어: "선라이즈 서핑",
        },
        text: {
          EN: "Riding waves in Miyako blue, crystal-clear water is a truly special experience. Seeing the sunrise from the ocean is also unique to Miyakojima. Because the morning sea is quieter, you can take your time and enjoy the waves at your own pace.",
          中文: "在透明度极高的宫古蓝海上乘浪，是非常特别的体验。从海上看日出的瞬间也只有宫古岛才有。清晨人少，可以按照自己的节奏慢慢享受海浪。",
          한국어:
            "투명도 높은 미야코 블루 바다에서 파도를 타는 경험은 정말 특별합니다. 바다 위에서 선라이즈를 보는 순간도 미야코지마다운 매력입니다. 아침 바다는 비교적 한적해서 자신의 페이스로 파도를 즐길 수 있습니다.",
        },
      },
      {
        title: {
          EN: "Multilingual support",
          中文: "多语言支持",
          한국어: "다국어 지원",
        },
        area: {
          EN: "Multilingual Guide",
          中文: "多语言向导",
          한국어: "다국어 가이드",
        },
        text: {
          EN: "Even if you speak a different language, surfing is easy to enjoy together. A veteran local guide who has guided many international guests supports you with simple English and gestures.",
          中文: "即使语言不同，冲浪的乐趣也能传达。拥有丰富海外游客带队经验的本地向导，会用简单英语和手势进行支持。",
          한국어:
            "언어가 달라도 서핑의 즐거움은 충분히 전해집니다. 많은 해외 게스트를 안내해 온 베테랑 로컬 가이드가 간단한 영어와 제스처로 서포트합니다.",
        },
      },
      {
        title: {
          EN: "Beginner-friendly surfing lessons",
          中文: "初学者也安心的冲浪课程",
          한국어: "초보자도 안심할 수 있는 서핑 레슨",
        },
        area: {
          EN: "Beginner Lesson",
          中文: "初学者课程",
          한국어: "초보자 레슨",
        },
        text: {
          EN: "Beginners can feel safe trying surfing. A veteran guide who knows Miyakojima's waves gives careful lessons and supports you so you can stand up and enjoy the ride.",
          中文: "初学者也可以安心挑战冲浪。熟悉宫古岛海浪的资深向导会细心教学，帮助您站起来享受乘浪的感觉。",
          한국어:
            "초보자도 안심하고 서핑에 도전할 수 있습니다. 미야코지마의 파도를 잘 아는 베테랑 가이드가 꼼꼼히 레슨하며 일어설 수 있도록 도와드립니다.",
        },
        rows: [
          [
            { EN: "Meeting", 中文: "集合", 한국어: "집합" },
            {
              EN: "Meet on site / location shared in advance",
              中文: "现场集合 / 集合地点事前通知",
              한국어: "현지 집합 / 장소는 사전 안내",
            },
          ],
          [
            { EN: "Included", 中文: "包含", 한국어: "포함 사항" },
            {
              EN: "Lesson fee / surfboard / reef boots",
              中文: "课程费用 / 冲浪板 / 礁石靴",
              한국어: "레슨비 / 서프보드 / 리프부츠",
            },
          ],
          [
            { EN: "For", 中文: "适合", 한국어: "대상" },
            { EN: "Beginners OK", 中文: "初学者OK", 한국어: "초보자 OK" },
          ],
          [
            { EN: "Price", 中文: "价格", 한국어: "요금" },
            {
              EN: "¥15,000 / person",
              中文: "¥15,000 / 人",
              한국어: "¥15,000 / 1인",
            },
          ],
        ],
      },
      {
        title: {
          EN: "Keep the wave-riding moment on video",
          中文: "用视频留下乘浪瞬间",
          한국어: "파도를 타는 순간을 영상으로 남기기",
        },
        area: {
          EN: "Surf Movie",
          中文: "冲浪视频",
          한국어: "서핑 영상",
        },
        text: {
          EN: "The moment you ride a wave and the clarity of the ocean are even more powerful on video. Keep your Miyakojima surfing experience as a memory you will want to watch again.",
          中文: "乘浪的瞬间和大海的透明感，用视频看会更有感染力。把宫古岛冲浪体验留成想反复回看的旅行回忆。",
          한국어:
            "파도를 타는 순간과 바다의 투명함은 영상으로 볼 때 더 잘 전해집니다. 미야코지마 서핑 체험을 몇 번이고 다시 보고 싶은 추억으로 남길 수 있습니다.",
        },
        rows: [
          [
            { EN: "Shooting option", 中文: "拍摄选项", 한국어: "촬영 옵션" },
            {
              EN: "Drone shooting +¥10,000 / group, +¥16,000 for 4 or more guests",
              中文: "无人机拍摄 +¥10,000 / 组，4人以上 +¥16,000",
              한국어: "드론 촬영 +¥10,000 / 1그룹, 4명 이상 +¥16,000",
            },
          ],
          [
            { EN: "Delivery", 中文: "交付", 한국어: "전달" },
            {
              EN: "Photo and video data delivered after the experience",
              中文: "体验后交付照片和视频数据",
              한국어: "체험 후 사진・영상 데이터 전달",
            },
          ],
          [
            { EN: "Recommended for", 中文: "推荐", 한국어: "추천" },
            {
              EN: "Travel videos and social posts",
              中文: "旅行视频 / SNS发布",
              한국어: "여행 영상 / SNS 게시",
            },
          ],
        ],
      },
    ],
  },
  "night-dinner-top5": {
    title: {
      EN: "Top 5 Dinner Spots in Miyakojima",
      中文: "宫古岛晚餐 TOP5",
      한국어: "미야코지마 저녁 맛집 TOP5",
    },
    text: {
      EN: "From island oden and live-music izakaya to local bars and Miyako beef, here are dinner spots to consider for your Miyakojima night.",
      中文: "从岛屿关东煮、民谣居酒屋到本地居酒屋和宫古牛，介绍宫古岛夜晚想去的晚餐店。",
      한국어:
        "섬 오뎅, 민요 이자카야, 로컬 이자카야, 미야코규까지 미야코지마의 밤에 가기 좋은 저녁 맛집을 소개합니다.",
    },
    description: {
      EN: "A guide to five dinner spots in Miyakojima, including island food, izakaya, live music, and Miyako beef.",
      中文: "宫古岛晚餐5选，包括岛料理、居酒屋、民谣现场和宫古牛。",
      한국어:
        "섬 요리, 이자카야, 민요 라이브, 미야코규까지 즐길 수 있는 미야코지마 저녁 맛집 5곳.",
    },
    leadText: {
      EN: "Miyakojima nights have a different charm from daytime beaches. This guide narrows dinner choices down to five easy options, from island food and lively izakaya to Miyako beef. Popular spots can fill up, so booking early is recommended.",
      中文: "宫古岛的夜晚有着不同于白天大海的魅力。这里精选5家适合晚餐的店，从岛料理、热闹居酒屋到宫古牛都包含在内。热门店容易客满，建议提前预约。",
      한국어:
        "미야코지마의 밤은 낮의 바다와는 또 다른 매력이 있습니다. 섬 요리, 활기 있는 이자카야, 미야코규까지 저녁 후보로 넣기 좋은 5곳을 추렸습니다. 인기점은 혼잡할 수 있어 빠른 예약을 추천합니다.",
    },
    toc: {
      EN: [
        "Dinner with Miyakojima island food",
        "Lively izakaya for the night",
        "A satisfying night with Miyako beef",
      ],
      中文: ["品尝宫古岛岛料理", "热闹的居酒屋夜晚", "宫古牛与肉料理晚餐"],
      한국어: [
        "미야코지마 섬 요리로 즐기는 저녁",
        "활기 있는 이자카야",
        "미야코규와 고기 요리로 만족하는 밤",
      ],
    },
    points: [
      {
        title: {
          EN: "Dinner with Miyakojima island food",
          中文: "品尝宫古岛岛料理",
          한국어: "미야코지마 섬 요리로 즐기는 저녁",
        },
        area: {
          EN: "Island food / izakaya / first night",
          中文: "岛料理 / 居酒屋 / 第一天晚上",
          한국어: "섬 요리 / 이자카야 / 첫날 밤",
        },
        text: {
          EN: "For a first Miyakojima dinner, island food is an easy choice. Enjoy Okinawan dishes and awamori in a relaxed island-night mood.",
          中文: "第一次来宫古岛晚餐，岛料理是很好选择。可以一边品尝冲绳料理和泡盛，一边感受岛上的夜晚。",
          한국어:
            "처음 미야코지마의 저녁이라면 섬 요리를 맛볼 수 있는 곳이 좋습니다. 오키나와 요리와 아와모리를 함께 즐기며 여행다운 밤을 보낼 수 있습니다.",
        },
      },
      {
        title: {
          EN: "Lively izakaya for the night",
          中文: "热闹的居酒屋夜晚",
          한국어: "활기 있는 이자카야",
        },
        area: {
          EN: "Izakaya / nightlife / group trip",
          中文: "居酒屋 / 夜生活 / 朋友旅行",
          한국어: "이자카야 / 밤 여행 / 그룹 여행",
        },
        text: {
          EN: "If you want to enjoy not only dinner but also the atmosphere of Miyakojima at night, izakaya are a good fit.",
          中文: "如果不仅想吃晚餐，也想感受宫古岛夜晚的氛围，居酒屋很适合。",
          한국어:
            "저녁 식사뿐 아니라 미야코지마 밤 분위기까지 즐기고 싶다면 이자카야를 추천합니다.",
        },
      },
      {
        title: {
          EN: "A satisfying night with Miyako beef",
          中文: "宫古牛与肉料理晚餐",
          한국어: "미야코규와 고기 요리로 만족하는 밤",
        },
        area: {
          EN: "Yakiniku / Miyako beef / special dinner",
          中文: "烤肉 / 宫古牛 / 特别晚餐",
          한국어: "야키니쿠 / 미야코규 / 특별한 저녁",
        },
        text: {
          EN: "For a more filling or special dinner, meat restaurants are also a strong choice after a beach or activity day.",
          中文: "想吃得满足一些，或想要特别一点的晚餐时，肉料理也很适合海边游玩后的一晚。",
          한국어:
            "든든하게 먹고 싶거나 조금 특별한 저녁을 원한다면 바다나 액티비티 후 고기 요리도 잘 어울립니다.",
        },
      },
    ],
  },
  "miyakojima-sweets-best14": {
    title: {
      EN: "14 Sweets Spots in Miyakojima",
      中文: "宫古岛甜点特集14选",
      한국어: "미야코지마 디저트 특집 14선",
    },
    text: {
      EN: "Smoothies, mango sweets, satapanbin, ice cream, donuts, crepes, and café desserts to try during your Miyakojima trip.",
      中文: "介绍宫古岛旅行中想品尝的冰沙、芒果甜点、satapanbin、冰淇淋、甜甜圈、可丽饼和咖啡馆甜点。",
      한국어:
        "스무디, 망고 디저트, 사타판빈, 아이스크림, 도넛, 크레이프, 카페 디저트까지 미야코지마에서 들르고 싶은 디저트 가게를 소개합니다.",
    },
    description: {
      EN: "A guide to 14 sweets shops to visit in Miyakojima, from smoothies and mango desserts to donuts, crepes, ice cream, and café sweets.",
      中文: "宫古岛甜点店14选，从冰沙、芒果甜点到甜甜圈、可丽饼、冰淇淋和咖啡馆甜点。",
      한국어:
        "스무디와 망고 디저트부터 도넛, 크레이프, 아이스크림, 카페 디저트까지 미야코지마 디저트 가게 14곳입니다.",
    },
    leadText: {
      EN: "Miyakojima has many sweets shops that are perfect between beach time and island drives. This article gathers smoothie shops, mango cafés, satapanbin, ice cream, donuts, crepes, and café sweets.",
      中文: "宫古岛有很多适合海边玩耍和自驾途中顺路的甜点店。这里整理了冰沙、芒果咖啡馆、satapanbin、冰淇淋、甜甜圈、可丽饼和咖啡馆甜点。",
      한국어:
        "미야코지마에는 바다와 드라이브 사이에 들르기 좋은 디저트 가게가 많습니다. 스무디, 망고 카페, 사타판빈, 아이스크림, 도넛, 크레이프, 카페 디저트를 모았습니다.",
    },
    toc: {
      EN: ["14 sweets spots in Miyakojima"],
      中文: ["宫古岛甜点14选"],
      한국어: ["미야코지마 디저트 14선"],
    },
    points: [
      {
        title: {
          EN: "14 sweets spots in Miyakojima",
          中文: "宫古岛甜点14选",
          한국어: "미야코지마 디저트 14선",
        },
        area: {
          EN: "Smoothies / mango / satapanbin / cafés",
          中文: "冰沙 / 芒果 / satapanbin / 咖啡馆",
          한국어: "스무디 / 망고 / 사타판빈 / 카페",
        },
        text: {
          EN: "From shops in town to stops on Irabu and Ikema Island drives, these are sweets spots to enjoy during your Miyakojima trip.",
          中文: "从市区容易前往的店，到伊良部岛、池间岛自驾途中适合顺路的店，整理了宫古岛旅行中想吃的甜点地点。",
          한국어:
            "시내에서 가기 쉬운 곳부터 이라부섬, 이케마섬 드라이브 중 들르기 좋은 곳까지 미야코지마 여행 중 즐기기 좋은 디저트 스팟입니다.",
        },
      },
    ],
  },
  "miyakojima-gelato-best5": {
    title: {
      EN: "5 Gelato and Ice Cream Spots in Miyakojima",
      中文: "宫古岛意式冰淇淋・冰品5选",
      한국어: "미야코지마 젤라토・아이스크림 5선",
    },
    text: {
      EN: "Ricco Gelato, Ninufa, Blue Seal, and other cold sweets to enjoy during your Miyakojima trip.",
      中文: "介绍旅途中想顺路品尝的リッコジェラート、Ninufa、Blue Seal 等冰品店。",
      한국어:
        "리ッコ젤라토, Ninufa, 블루씰 등 미야코지마 여행 중 들르기 좋은 차가운 디저트를 소개합니다.",
    },
    description: {
      EN: "A guide to five gelato and ice cream spots to visit during a Miyakojima trip.",
      中文: "宫古岛旅行中想去的意式冰淇淋和冰品店5选。",
      한국어: "미야코지마 여행 중 들르기 좋은 젤라토와 아이스크림 5곳.",
    },
    leadText: {
      EN: "On hot Miyakojima days or during an island drive, gelato and ice cream are perfect breaks. This guide collects five easy stops, from popular shops in town to cafés on Ikema and Irabu Island.",
      中文: "宫古岛炎热的日子或自驾途中，冷冰冰的甜点最适合休息。这里整理了市区人气店、池间岛和伊良部岛途中容易顺路的5家店。",
      한국어:
        "더운 미야코지마 날이나 드라이브 중에는 젤라토와 아이스크림이 좋은 휴식이 됩니다. 시내 인기점부터 이케마섬, 이라부섬 드라이브 중 들르기 좋은 5곳을 모았습니다.",
    },
    toc: {
      EN: [
        "Gelato spots easy to visit in town",
        "Ice cream stops during a drive",
        "Sweets with Miyakojima ingredients",
      ],
      中文: [
        "市区方便前往的冰品店",
        "自驾途中想顺路的冰品",
        "感受宫古岛素材的甜点",
      ],
      한국어: [
        "시내에서 가기 쉬운 젤라토",
        "드라이브 중 들르기 좋은 아이스크림",
        "미야코지마다운 재료를 즐기는 디저트",
      ],
    },
    points: [
      {
        title: {
          EN: "Gelato spots easy to visit in town",
          中文: "市区方便前往的冰品店",
          한국어: "시내에서 가기 쉬운 젤라토",
        },
        area: {
          EN: "Hirara / dessert after dinner / town walk",
          中文: "平良 / 饭后甜点 / 市区散步",
          한국어: "히라라 / 식후 디저트 / 시내 산책",
        },
        text: {
          EN: "These are easy to add after dinner or while walking around town, especially if you are staying near Hirara.",
          中文: "这些店适合晚餐后或市区散步时顺路前往，住在平良周边的话很方便。",
          한국어:
            "저녁 식사 후나 시내 산책 중 들르기 좋고, 히라라 주변 숙소라면 일정에 넣기 쉽습니다.",
        },
      },
      {
        title: {
          EN: "Ice cream stops during a drive",
          中文: "自驾途中想顺路的冰品",
          한국어: "드라이브 중 들르기 좋은 아이스크림",
        },
        area: {
          EN: "Ikema Island / Irabu Island / drive",
          中文: "池间岛 / 伊良部岛 / 自驾",
          한국어: "이케마섬 / 이라부섬 / 드라이브",
        },
        text: {
          EN: "Perfect stops on a day when you are heading to the ocean. They work well as a cool break and a small photo stop.",
          中文: "适合安排在看海自驾途中，既能休息消暑，也能顺手拍照。",
          한국어:
            "바다를 보러 가는 날 들르기 좋은 곳입니다. 더위를 식히는 휴식과 사진 남기기에도 잘 어울립니다.",
        },
      },
      {
        title: {
          EN: "Sweets with Miyakojima ingredients",
          中文: "感受宫古岛素材的甜点",
          한국어: "미야코지마다운 재료를 즐기는 디저트",
        },
        area: {
          EN: "Yukishio / island ingredients / souvenirs",
          中文: "雪盐 / 岛素材 / 伴手礼",
          한국어: "유키시오 / 섬 재료 / 기념품",
        },
        text: {
          EN: "For something that feels especially Miyakojima, try sweets made with local salt or island ingredients.",
          中文: "想要更有宫古岛特色，可以选择使用雪盐或岛上素材的甜点。",
          한국어:
            "미야코지마다운 느낌을 원한다면 눈소금이나 섬 재료를 사용한 디저트도 추천합니다.",
        },
      },
    ],
  },
  "miyakojima-yakiniku-top3": {
    title: {
      EN: "Top 3 Yakiniku Restaurants in Miyakojima",
      中文: "宫古岛烤肉店TOP3",
      한국어: "미야코지마 야키니쿠 TOP 3",
    },
    text: {
      EN: "Three yakiniku restaurants for Miyako beef dinners, with approximate price ranges.",
      中文: "介绍适合享受宫古牛晚餐的3家烤肉店，并附价格带参考。",
      한국어:
        "미야코규 저녁 식사로 가기 좋은 야키니쿠 맛집 3곳과 대략적인 가격대를 소개합니다.",
    },
    description: {
      EN: "A guide to the top three yakiniku restaurants to visit at night in Miyakojima, including approximate price ranges.",
      中文: "宫古岛旅行夜晚想去的烤肉店TOP3，包含价格带参考。",
      한국어:
        "미야코지마 여행의 밤에 가기 좋은 야키니쿠 맛집 TOP 3와 대략적인 가격대입니다.",
    },
    leadText: {
      EN: "After a day at the ocean, yakiniku is a great choice for dinner. Here are three restaurants for Miyako beef and a special travel night. Prices are approximate, so check the latest menu before visiting.",
      中文: "在海边玩了一天后，烤肉很适合作为晚餐。这里精选3家适合享受宫古牛和特别旅行夜晚的店铺。价格为参考，请在来店前确认最新菜单。",
      한국어:
        "바다에서 놀고 난 밤에는 야키니쿠가 잘 어울립니다. 미야코규와 특별한 여행의 밤에 어울리는 3곳을 골랐습니다. 가격은 기준이며 방문 전 최신 메뉴를 확인하세요.",
    },
    toc: {
      EN: [
        "No. 1: Yakiniku Nakao",
        "No. 2: Yakiniku Kihachi",
        "No. 3: Yakimusha",
      ],
      中文: ["第1名：烧肉Nakao", "第2名：烧肉喜八", "第3名：烧武者"],
      한국어: ["1위: 야키니쿠 나카오", "2위: 야키니쿠 키하치", "3위: 야키무샤"],
    },
    points: [
      {
        title: {
          EN: "No. 1: Yakiniku Nakao",
          中文: "第1名：烧肉Nakao",
          한국어: "1위: 야키니쿠 나카오",
        },
        text: {
          EN: "A strong option when you want to enjoy Miyako beef properly. It is a good fit for a special dinner, anniversary, or girls' trip night.",
          中文: "想好好享受宫古牛时很适合选择。适合特别晚餐、纪念日或女生旅行的夜晚。",
          한국어:
            "미야코규를 제대로 즐기고 싶을 때 좋은 선택입니다. 특별한 저녁, 기념일, 여자 여행의 밤에도 잘 어울립니다.",
        },
      },
      {
        title: {
          EN: "No. 2: Yakiniku Kihachi",
          中文: "第2名：烧肉喜八",
          한국어: "2위: 야키니쿠 키하치",
        },
        text: {
          EN: "A popular choice for yakiniku in Miyakojima. Recommended when you want a satisfying dinner after sightseeing or ocean activities.",
          中文: "宫古岛烤肉的热门选择。观光或海上活动后，想吃一顿满足的晚餐时推荐。",
          한국어:
            "미야코지마에서 야키니쿠를 먹고 싶을 때 인기 있는 선택지입니다. 관광이나 바다 활동 후 든든한 저녁으로 추천합니다.",
        },
      },
      {
        title: {
          EN: "No. 3: Yakimusha",
          中文: "第3名：烧武者",
          한국어: "3위: 야키무샤",
        },
        text: {
          EN: "A good choice for a calmer yakiniku dinner. Check hours and availability early once your travel dates are set.",
          中文: "适合想安静享受烤肉晚餐时选择。旅行日期确定后，建议尽早确认营业时间和座位。",
          한국어:
            "조금 차분하게 야키니쿠 저녁을 즐기고 싶을 때 좋은 후보입니다. 여행 일정이 정해지면 영업시간과 예약 가능 여부를 미리 확인하세요.",
        },
      },
    ],
  },
  "model-course-3n4d": {
    title: {
      EN: "3-Night, 4-Day Miyakojima Model Plan",
      中文: "宫古岛3晚4天旅行计划",
      한국어: "미야코지마 3박 4일 모델 플랜",
    },
    text: {
      EN: "A relaxed plan with a photo tour, hidden SUP, Yabiji, sunset, dinner, and star photography.",
      中文: "结合摄影、秘境SUP、八重干濑、夕阳、晚餐和星空拍摄的轻松行程。",
      한국어:
        "촬영 투어, 비경 SUP, 야비지, 석양, 저녁 식사, 별 사진 촬영을 여유롭게 담은 플랜입니다.",
    },
    description: {
      EN: "A 3-night, 4-day Miyakojima itinerary with scenic photo tours, hidden SUP, Yabiji, sunset, dinner, star photography, and cafe breakfast.",
      中文: "包含绝景摄影、秘境SUP、八重干濑、夕阳、晚餐、星空拍摄和咖啡早餐的宫古岛3晚4天行程。",
      한국어:
        "절경 촬영, 비경 SUP, 야비지, 석양, 저녁 식사, 별 사진 촬영, 카페 아침을 담은 미야코지마 3박 4일 일정입니다.",
    },
    leadText: {
      EN: "With three nights, you can enjoy the ocean, photography, food, and stars without squeezing everything into one day. Splitting activities by day keeps the trip relaxed and memorable.",
      中文: "3晚4天可以不把所有行程塞进一天，轻松享受大海、摄影、美食和星空。按天分开体验，更不累也更容易留下回忆。",
      한국어:
        "3박 4일이면 바다, 촬영, 맛집, 별까지 하루에 몰아넣지 않고 즐길 수 있습니다. 날짜별로 체험을 나누면 덜 지치고 추억도 더 선명하게 남습니다.",
    },
    toc: {
      EN: [
        "Day 1: Scenic photo tour or hidden SUP",
        "Day 2: Yabiji tour, sunset, and dinner",
        "Day 3: Relax at beaches and cafes, then star photography",
        "Day 4: Cafe breakfast and airport",
      ],
      中文: [
        "第1天：绝景摄影或秘境SUP",
        "第2天：八重干濑行程、夕阳与晚餐",
        "第3天：海滩和咖啡馆慢慢过，夜晚星空拍摄",
        "第4天：咖啡馆早餐后前往机场",
      ],
      한국어: [
        "1일차: 절경 촬영 투어 또는 비경 SUP",
        "2일차: 야비지 투어, 석양, 저녁 식사",
        "3일차: 해변과 카페에서 여유롭게, 밤에는 별 사진",
        "4일차: 카페 아침 식사 후 공항으로",
      ],
    },
    points: [
      {
        title: {
          EN: "Day 1: Scenic photo tour or hidden SUP",
          中文: "第1天：绝景摄影或秘境SUP",
          한국어: "1일차: 절경 촬영 투어 또는 비경 SUP",
        },
        text: {
          EN: "Start with a scenic photo tour or hidden SUP. It is the easiest way to capture Miyakojima's ocean and atmosphere early in the trip.",
          中文: "旅程开始安排绝景摄影或秘境SUP，最容易在旅行前半段留下宫古岛的海和空气感。",
          한국어:
            "첫날은 절경 촬영 투어 또는 비경 SUP로 시작해 보세요. 여행 초반에 미야코지마의 바다와 분위기를 남기기 좋습니다.",
        },
      },
      {
        title: {
          EN: "Day 2: Yabiji tour, sunset, and dinner",
          中文: "第2天：八重干濑行程、夕阳与晚餐",
          한국어: "2일차: 야비지 투어, 석양, 저녁 식사",
        },
        text: {
          EN: "Enjoy Yabiji from the morning, watch the sunset in the evening, then finish the day with island food, izakaya, or yakiniku.",
          中文: "上午享受八重干濑，傍晚看夕阳，晚上用岛料理、居酒屋或烤肉结束一天。",
          한국어:
            "아침부터 야비지를 즐기고 저녁에는 석양을 본 뒤 섬 음식, 이자카야, 야키니쿠로 하루를 마무리합니다.",
        },
      },
      {
        title: {
          EN: "Day 3: Relax at beaches and cafes, then star photography",
          中文: "第3天：海滩和咖啡馆慢慢过，夜晚星空拍摄",
          한국어: "3일차: 해변과 카페에서 여유롭게, 밤에는 별 사진",
        },
        text: {
          EN: "Keep the daytime easy with beaches and cafes, then head out for star photography at night when the sky is clear.",
          中文: "白天在海滩和咖啡馆轻松度过，夜晚若天气好就安排星空拍摄。",
          한국어:
            "낮에는 해변과 카페에서 여유롭게 보내고, 밤에는 날씨가 좋을 때 별 사진 촬영을 넣어보세요.",
        },
      },
      {
        title: {
          EN: "Day 4: Cafe breakfast and airport",
          中文: "第4天：咖啡馆早餐后前往机场",
          한국어: "4일차: 카페 아침 식사 후 공항으로",
        },
        text: {
          EN: "On the final morning, have breakfast at a cafe, pick up souvenirs, return the rental car, and head to the airport with time to spare.",
          中文: "最后一天早上在咖啡馆吃早餐，购买伴手礼，还车后留出时间前往机场。",
          한국어:
            "마지막 아침은 카페에서 식사하고 기념품을 산 뒤 렌터카를 반납하고 여유 있게 공항으로 향합니다.",
        },
      },
    ],
  },
  "miyakojima-superb-view-spots": {
    title: {
      EN: "Must-Visit Scenic Spots in Miyakojima",
      中文: "宫古岛旅行必去绝景景点",
      한국어: "미야코지마 여행에서 꼭 가고 싶은 절경 스팟",
    },
    text: {
      EN: "From classic scenic spots to hidden beaches and a private scenic photo tour for an extraordinary Miyakojima experience.",
      中文: "从经典绝景到秘境海滩，以及能体验非日常的私人绝景摄影行程。",
      한국어:
        "대표 절경부터 비밀 해변, 특별한 비일상 체험을 남기는 프라이빗 절경 촬영 투어까지 소개합니다.",
    },
    description: {
      EN: "A guide to must-visit scenic spots in Miyakojima, including Yonaha Maehama, Sunayama Beach, Irabu Island, Blue Cave, Higashi-Hennazaki, and a scenic photo tour for travelers seeking an extraordinary experience.",
      中文: "介绍宫古岛旅行必去绝景景点，包括与那霸前滨、砂山海滩、伊良部岛、青之洞窟、东平安名崎，以及适合想体验非日常的绝景摄影行程。",
      한국어:
        "요나하 마에하마, 스나야마 비치, 이라부섬, 푸른 동굴, 히가시헨나자키 등 미야코지마 필수 절경과 비일상 체험을 위한 절경 촬영 투어를 소개합니다.",
    },
    leadText: {
      EN: "Miyakojima is full of views that make you want to stop and take photos: white sand beaches, Miyako blue water, bridge views, and quiet hidden beaches. If you want a truly special experience, a scenic photo tour lets you keep those moments as photos, videos, and drone footage.",
      中文: "宫古岛有许多让人想停下来拍照的景色：白沙海滩、宫古蓝大海、桥上风景和安静秘境海滩。如果想要更特别的体验，绝景摄影行程能把这些瞬间以照片、视频和无人机影像留下。",
      한국어:
        "미야코지마에는 하얀 모래 해변, 미야코 블루 바다, 다리에서 보는 풍경, 조용한 비밀 해변처럼 사진으로 남기고 싶은 장면이 많습니다. 특별한 경험을 원한다면 절경 촬영 투어로 사진, 영상, 드론 촬영까지 남길 수 있습니다.",
    },
    toc: {
      EN: [
        "Classic scenic spots in Miyakojima",
        "Hidden spots for an extraordinary mood",
        "Keep the experience with a scenic photo tour",
      ],
      中文: [
        "宫古岛经典绝景景点",
        "能感受非日常的秘境地点",
        "用绝景摄影行程留下回忆",
      ],
      한국어: [
        "미야코지마의 대표 절경 스팟",
        "비일상감을 느낄 수 있는 숨은 장소",
        "절경 촬영 투어로 경험을 남기기",
      ],
    },
    points: [
      {
        title: {
          EN: "Classic scenic spots in Miyakojima",
          中文: "宫古岛经典绝景景点",
          한국어: "미야코지마의 대표 절경 스팟",
        },
        text: {
          EN: "For a first trip, Yonaha Maehama, Sunayama Beach, Irabu Bridge, and Kurima Island are easy choices. The white sand, blue water, and ocean gradients are perfect for travel photos.",
          中文: "第一次来宫古岛，与那霸前滨、砂山海滩、伊良部大桥、来间岛都很适合。白沙、蓝海和海色渐层很容易拍出旅行照片。",
          한국어:
            "첫 미야코지마 여행이라면 요나하 마에하마, 스나야마 비치, 이라부대교, 쿠리마섬이 좋습니다. 하얀 모래와 푸른 바다, 바다 그라데이션이 여행 사진에 잘 어울립니다.",
        },
      },
      {
        title: {
          EN: "Hidden spots for an extraordinary mood",
          中文: "能感受非日常的秘境地点",
          한국어: "비일상감을 느낄 수 있는 숨은 장소",
        },
        text: {
          EN: "Miyakojima also has quieter beaches and spots that change with sea conditions. Check tides, safety, and local rules before visiting hidden areas.",
          中文: "宫古岛也有游客较少、会随海况变化的地点。前往秘境区域前，请务必确认潮位、安全和当地规则。",
          한국어:
            "미야코지마에는 사람이 적고 해황에 따라 분위기가 달라지는 장소도 있습니다. 숨은 장소를 방문할 때는 조수, 안전, 현지 규칙을 꼭 확인하세요.",
        },
      },
      {
        title: {
          EN: "Keep the experience with a scenic photo tour",
          中文: "用绝景摄影行程留下回忆",
          한국어: "절경 촬영 투어로 경험을 남기기",
        },
        text: {
          EN: "For travelers who want an extraordinary Miyakojima experience, the scenic photo tour is a great fit. Visit hidden and photogenic spots while keeping the day as photos, videos, and drone footage.",
          中文: "想在宫古岛体验非日常的旅行者，很适合参加绝景摄影行程。巡游秘境和适合拍照的地点，并以照片、视频和无人机影像留下这一天。",
          한국어:
            "미야코지마에서 특별한 비일상 체험을 원한다면 절경 촬영 투어가 잘 맞습니다. 숨은 장소와 사진 명소를 돌며 사진, 영상, 드론 촬영으로 하루를 남길 수 있습니다.",
        },
      },
    ],
  },
  "miyakojima-cheap-local-rentacar": {
    title: {
      EN: "Cheap Local Rental Cars in Miyakojima",
      中文: "宫古岛平价本地租车整理",
      한국어: "미야코지마 저렴한 로컬 렌터카 정리",
    },
    text: {
      EN: "Local budget rental car options in Miyakojima and what to check before booking.",
      中文: "宫古岛本地平价租车选择，以及预约前需要确认的重点。",
      한국어:
        "미야코지마의 저렴한 로컬 렌터카 후보와 예약 전 확인할 점을 정리했습니다.",
    },
    description: {
      EN: "A guide for travelers who want to rent a car cheaply in Miyakojima, covering local budget rental car companies, price ranges, airport transfers, insurance, and vehicle condition checks.",
      中文: "面向想在宫古岛便宜租车的旅行者，整理本地平价租车、价格目安、机场接送、保险和车辆状态确认要点。",
      한국어:
        "미야코지마에서 렌터카를 저렴하게 빌리고 싶은 여행자를 위한 로컬 렌터카, 가격대, 공항 픽업, 보험, 차량 상태 체크 가이드입니다.",
    },
    leadText: {
      EN: "A rental car makes it much easier to visit beaches, cafes, and scenic spots in Miyakojima. During peak season, prices rise and major companies can fill up early, so local budget rental cars are worth checking. Compare total cost, insurance, transfer areas, and vehicle condition before booking.",
      中文: "有租车的话，宫古岛的海滩、咖啡馆和绝景景点会更好安排。旺季价格容易上涨，大型租车也可能很早订满，因此本地平价租车值得考虑。预约前请比较总价、保险、接送范围和车辆状态。",
      한국어:
        "렌터카가 있으면 미야코지마의 해변, 카페, 절경 스팟을 훨씬 편하게 돌 수 있습니다. 성수기에는 가격이 오르고 대형 업체가 빨리 마감될 수 있어 로컬 저가 렌터카도 확인해 볼 만합니다. 예약 전 총액, 보험, 픽업 범위, 차량 상태를 비교하세요.",
    },
    toc: {
      EN: [
        "Local rental cars for travelers who want the lowest price",
        "Options with airport transfer and insurance",
        "What to check before booking a very cheap rental car",
      ],
      中文: [
        "适合想便宜租车的本地租车",
        "重视机场接送和保险的人适合的选择",
        "预约超便宜租车前需要确认的事项",
      ],
      한국어: [
        "가격을 중시하는 여행자를 위한 로컬 렌터카",
        "공항 픽업과 보험을 보고 고르는 선택지",
        "저렴한 렌터카 예약 전 확인할 점",
      ],
    },
    points: [
      {
        title: {
          EN: "Local rental cars for travelers who want the lowest price",
          中文: "适合想便宜租车的本地租车",
          한국어: "가격을 중시하는 여행자를 위한 로컬 렌터카",
        },
        text: {
          EN: "If price is the priority, look for local rental cars with kei cars or used-car plans. In normal seasons, some options can be around 3,000 to 4,000 yen per day.",
          中文: "如果优先考虑价格，可以寻找提供轻自动车或二手车方案的本地租车。普通季节有些方案一天约3,000～4,000日元起。",
          한국어:
            "가격이 가장 중요하다면 경차나 중고차 플랜이 있는 로컬 렌터카를 확인해 보세요. 일반 시즌에는 하루 3,000~4,000엔대 플랜도 보일 수 있습니다.",
        },
      },
      {
        title: {
          EN: "Options with airport transfer and insurance",
          中文: "重视机场接送和保险的人适合的选择",
          한국어: "공항 픽업과 보험을 보고 고르는 선택지",
        },
        text: {
          EN: "Do not compare only the displayed price. Airport transfer, collision damage waiver, NOC, and extra fees can change the final total.",
          中文: "不要只比较页面上显示的价格。机场接送、免赔补偿、NOC和追加费用都会影响最终总价。",
          한국어:
            "표시 가격만 비교하지 마세요. 공항 픽업, 면책 보상, NOC, 추가 요금에 따라 최종 금액이 달라질 수 있습니다.",
        },
      },
      {
        title: {
          EN: "What to check before booking a very cheap rental car",
          中文: "预约超便宜租车前需要确认的事项",
          한국어: "저렴한 렌터카 예약 전 확인할 점",
        },
        text: {
          EN: "Very cheap plans can save money, but check the car age, scratches, air conditioning, insurance, transfer area, payment methods, and what happens if there is a vehicle issue.",
          中文: "超便宜方案可以节省费用，但请确认车辆年式、划痕、空调、保险、接送范围、付款方式，以及车辆故障时的应对方式。",
          한국어:
            "아주 저렴한 플랜은 비용을 아낄 수 있지만 차량 연식, 흠집, 에어컨, 보험, 픽업 범위, 결제 방법, 차량 문제 발생 시 대응을 확인해야 합니다.",
        },
      },
    ],
  },
  "one-day-photogenic-tour-experience": {
    title: {
      EN: "What the Scenic Photo Tour Is Like",
      中文: "绝景摄影行程体验介绍",
      한국어: "절경 촬영 투어의 분위기 소개",
    },
    text: {
      EN: "A look at the private scenic tour, hidden spots, drone shooting, and the atmosphere of the day.",
      中文: "介绍私人绝景行程、秘境地点、无人机拍摄和当天氛围。",
      한국어:
        "프라이빗 절경 투어, 숨은 장소, 드론 촬영, 당일 분위기를 소개합니다.",
    },
    description: {
      EN: "What you can experience on the Miyakojima scenic photo tour, from hidden spots to camera and drone shooting.",
      中文: "介绍宫古岛绝景摄影行程中能体验的秘境巡游、相机拍摄和无人机拍摄。",
      한국어:
        "미야코지마 절경 촬영 투어에서 경험할 수 있는 숨은 장소, 카메라 촬영, 드론 촬영을 소개합니다.",
    },
    leadText: {
      EN: "This is not just sightseeing. The scenic tour takes you to Miyakojima's ocean, bridges, and hidden spots while capturing the day with photos, videos, and drone footage.",
      中文: "这不只是普通观光。绝景行程会巡游宫古岛的大海、大桥和秘境，并用照片、视频和无人机影像记录这一天。",
      한국어:
        "단순한 관광이 아닙니다. 절경 투어는 미야코지마의 바다, 다리, 숨은 장소를 돌며 사진, 영상, 드론으로 하루를 남깁니다.",
    },
    toc: {
      EN: [
        "Visit hidden scenic spots",
        "Enjoy Miyakojima while being photographed",
        "Keep the memories as photos and videos",
      ],
      中文: ["巡游秘境绝景", "一边游玩一边拍摄", "用照片和视频留下回忆"],
      한국어: [
        "숨은 절경 스팟 방문",
        "촬영하며 미야코지마 즐기기",
        "사진과 영상으로 추억 남기기",
      ],
    },
  },
  "hidden-sup-tour-experience": {
    title: {
      EN: "What the Hidden SUP Tour Is Like",
      中文: "秘境SUP行程体验介绍",
      한국어: "비경 SUP 투어의 분위기 소개",
    },
    text: {
      EN: "A quiet SUP experience on a less crowded Miyako blue ocean, with photos and videos.",
      中文: "在人少的宫古蓝海上体验安静SUP，并留下照片和视频。",
      한국어:
        "사람이 적은 미야코 블루 바다에서 즐기는 조용한 SUP 체험과 사진・영상입니다.",
    },
    description: {
      EN: "The atmosphere and flow of the hidden SUP tour, including quiet beaches, ocean time, and shooting.",
      中文: "介绍秘境SUP行程的氛围和流程，包括安静海滩、海上时间和拍摄。",
      한국어:
        "조용한 해변, 바다 위 시간, 촬영까지 비경 SUP 투어의 분위기와 흐름을 소개합니다.",
    },
    leadText: {
      EN: "Hidden SUP is perfect for travelers who want to avoid crowded beaches and relax on a quiet Miyakojima ocean.",
      中文: "秘境SUP很适合想避开人多海滩、在安静宫古岛海上放松的旅行者。",
      한국어:
        "비경 SUP는 붐비는 해변을 피하고 조용한 미야코지마 바다에서 쉬고 싶은 여행자에게 잘 맞습니다.",
    },
    toc: {
      EN: [
        "SUP on a quiet ocean",
        "Have the beautiful sea to yourself",
        "Capture the mood with photos and videos",
      ],
      中文: ["在人少的海上体验SUP", "独享美丽大海", "用照片和视频留下氛围"],
      한국어: [
        "조용한 바다에서 SUP",
        "아름다운 바다를 독차지",
        "사진과 영상으로 분위기 남기기",
      ],
    },
  },
  "jet-private-secret-tour-experience": {
    title: {
      EN: "What the Private Jet Ski Tour Is Like",
      中文: "私人摩托艇行程体验介绍",
      한국어: "프라이빗 제트스키 투어의 분위기 소개",
    },
    text: {
      EN: "A private tour to Yuni Beach and secret beaches only reachable by jet ski.",
      中文: "前往幻之滨和只有摩托艇才能抵达的秘境海滩的私人行程。",
      한국어:
        "유니노하마와 제트스키로만 갈 수 있는 비밀 해변으로 향하는 프라이빗 투어입니다.",
    },
    description: {
      EN: "The flow of the private jet ski tour, including meeting, Yuni Beach, secret beaches, drone shooting, and data delivery.",
      中文: "介绍私人摩托艇行程流程，包括集合、幻之滨、秘境海滩、无人机拍摄和数据交付。",
      한국어:
        "집합, 유니노하마, 시크릿 비치, 드론 촬영, 데이터 전달까지 프라이빗 제트스키 투어의 흐름입니다.",
    },
    leadText: {
      EN: "This jet ski tour takes you beyond places reachable by car or on foot, to Yuni Beach and secret beaches selected by the sea conditions of the day.",
      中文: "这项摩托艇行程会带你前往车和步行无法抵达的海域，根据当天海况前往幻之滨和秘境海滩。",
      한국어:
        "이 제트스키 투어는 차나 도보로 갈 수 없는 바다 너머, 당일 해황에 맞춘 유니노하마와 시크릿 비치로 향합니다.",
    },
    toc: {
      EN: [
        "Meet locally and head to the best point",
        "Visit Yuni Beach and secret beaches",
        "Keep the memory with drone shooting",
      ],
      中文: [
        "现地集合后前往最佳地点",
        "前往幻之滨和秘境海滩",
        "用无人机拍摄留下回忆",
      ],
      한국어: [
        "현지 집합 후 최적의 포인트로",
        "유니노하마와 시크릿 비치 방문",
        "드론 촬영으로 추억 남기기",
      ],
    },
  },
  "girls-trip-model-course-2n3d": {
    title: {
      EN: "Photogenic Girls Trip in Miyakojima: 2 Nights 3 Days Model Course",
      中文: "宫古岛女生打卡旅行！2晚3天行程范例",
      한국어: "미야코지마 감성 여자 여행! 2박 3일 모델 코스",
    },
    text: {
      EN: "A 2-night, 3-day girls trip route with photos, cafés, beaches, sunset, and island dinner.",
      中文: "包含拍照、咖啡、海滩、夕阳和晚餐的2晚3天女生旅行路线。",
      한국어: "사진, 카페, 해변, 선셋, 저녁까지 즐기는 2박 3일 여자 여행 코스.",
    },
    description: {
      EN: "A 2-night, 3-day Miyakojima girls trip itinerary that balances beaches, cafés, sunset, dinner, and photo moments without overpacking the schedule.",
      中文: "宫古岛女生旅行2晚3天行程，轻松安排海滩、咖啡、夕阳、晚餐和拍照时间。",
      한국어:
        "해변, 카페, 선셋, 저녁, 촬영 시간을 무리 없이 담은 미야코지마 2박 3일 여자 여행 코스입니다.",
    },
    leadText: {
      EN: "A girls trip in Miyakojima is best when the schedule leaves space for the ocean, cafés, sunset, and photos. This route splits the trip by area so you can enjoy the island without feeling rushed.",
      中文: "宫古岛女生旅行最好不要安排得太满。这个路线按区域安排大海、咖啡、夕阳和拍照时间，让旅行更轻松。",
      한국어:
        "미야코지마 여자 여행은 바다, 카페, 선셋, 사진을 여유롭게 남길 수 있을 때 더 좋습니다. 동선별로 나누어 무리하지 않게 즐기는 코스입니다.",
    },
    toc: {
      EN: [
        "Day 1: Start with Irabu Island and sunset",
        "Day 2: Hidden photo tour or hidden SUP",
        "Day 3: Slow café and beach time before departure",
      ],
      中文: [
        "第1天：伊良部岛和夕阳",
        "第2天：秘境摄影行程或秘境SUP",
        "第3天：咖啡和海滩后返程",
      ],
      한국어: [
        "1일차: 이라부섬과 선셋",
        "2일차: 비경 포토 투어 또는 비경 SUP",
        "3일차: 카페와 해변 후 공항으로",
      ],
    },
    cta: {
      title: {
        EN: "Keep your girls trip as photos and videos",
        中文: "用照片和影片留下女生旅行",
        한국어: "여자 여행을 사진과 영상으로 남기기",
      },
      text: {
        EN: "We guide you to quiet hidden spots and private beaches for photos and videos you will want to share.",
        中文: "带你前往人少的秘境和私人海滩，留下想分享到SNS的照片和影片。",
        한국어:
          "한적한 비경과 프라이빗 비치로 안내해 SNS에 올리고 싶은 사진과 영상을 남깁니다.",
      },
      buttonText: {
        EN: "View the Hidden Photo Tour",
        中文: "查看秘境摄影行程",
        한국어: "비경 포토 투어 보기",
      },
    },
  },
  "miyakojima-girls-trip-hotels": {
    title: {
      EN: "6 Hotel Types Recommended for Girls Trips in Miyakojima",
      中文: "宫古岛女生旅行推荐酒店6选",
      한국어: "미야코지마 여자 여행에 추천하는 호텔 6선",
    },
    text: {
      EN: "Choose a girls-trip hotel by photogenic mood, pool, ocean view, and access.",
      中文: "从拍照氛围、泳池、海景和交通便利度选择女生旅行酒店。",
      한국어: "사진 분위기, 수영장, 오션뷰, 접근성으로 고르는 여자 여행 호텔.",
    },
    description: {
      EN: "Hotel ideas for girls trips in Miyakojima, grouped by resort feel, private villas, Irabu Island stays, city access, ocean views, and cost performance.",
      中文: "按度假感、泳池别墅、伊良部岛住宿、市区交通、海景和性价比介绍宫古岛女生旅行酒店。",
      한국어:
        "리조트감, 풀빌라, 이라부섬 숙소, 시내 접근성, 오션뷰, 가성비로 나누어 보는 미야코지마 여자 여행 호텔입니다.",
    },
    leadText: {
      EN: "For a girls trip, choose a hotel not only by price, but also by atmosphere, access to dinner, ocean views, and how easy it is to enjoy your morning and night.",
      中文: "女生旅行选酒店时，不只看价格，也要看氛围、晚餐交通、海景和早晚是否好度过。",
      한국어:
        "여자 여행 호텔은 가격뿐 아니라 분위기, 저녁 식사 접근성, 오션뷰, 아침과 밤을 보내기 좋은지도 함께 보는 것이 좋습니다.",
    },
    toc: {
      EN: [
        "Resort-feel hotels",
        "Private pool villas",
        "Irabu Island stay",
        "City access",
        "Ocean view",
        "Cost-performance hotels",
      ],
      中文: [
        "度假感酒店",
        "泳池别墅",
        "伊良部岛住宿",
        "市区交通便利",
        "海景重视",
        "性价比酒店",
      ],
      한국어: [
        "리조트형 호텔",
        "풀빌라",
        "이라부섬 숙소",
        "시내 접근성",
        "오션뷰",
        "가성비 호텔",
      ],
    },
  },
  "miyako-hotel-guide-by-area": {
    title: {
      EN: "Miyakojima Hotels & Resorts by Area",
      中文: "【按区域】宫古岛推荐酒店・度假村",
      한국어: "【지역별】미야코지마 추천 호텔・리조트",
    },
    description: {
      EN: "Hotels and resorts in Miyakojima organized by area — Irabu Island, Shigira, Ueno/Aragusuku, Kurima Island, and the Yonaha Maehama area — from private-pool villas to large resorts.",
      中文: "按伊良部岛、系拉、上野・新城、来间岛、与那覇前浜周边等区域，介绍宫古岛的酒店与度假村，从泳池别墅到大型度假村应有尽有。",
      한국어:
        "이라부섬, 시기라, 우에노・아라구스쿠, 쿠리마섬, 요나하마에하마 주변 등 지역별로 미야코지마의 호텔・리조트를 소개합니다. 풀빌라부터 대형 리조트까지 폭넓게 정리했습니다.",
    },
    leadText: {
      EN: "Miyakojima's hotel character changes a lot depending on the area — Irabu/Shimoji Island, Shigira, Ueno/Aragusuku, Kurima Island, and more. Where you stay affects how easy it is to sightsee and how you'll spend your time, so here's a rundown of hotels and resorts organized by area.",
      中文: "宫古岛的酒店氛围会因区域而有很大不同，例如伊良部・下地岛、系拉、上野・新城、来间岛等。住在哪个区域会影响观光的便利度和度假方式，因此这里按区域整理了推荐的酒店与度假村，供订房时参考。",
      한국어:
        "미야코지마는 이라부・시모지섬, 시기라, 우에노・아라구스쿠, 쿠리마섬 등 지역에 따라 호텔의 분위기가 꽤 다릅니다. 어디에 묵느냐에 따라 관광 편의성과 지내는 방식도 달라지므로, 지역별 특징과 함께 추천 호텔・리조트를 정리했습니다.",
    },
    toc: {
      EN: [
        "Irabu / Shimoji Island Area",
        "Shigira / Ueno Area",
        "Hirara / North Area",
        "Kurima Island Area",
        "Yonaha Maehama Area",
      ],
      中文: [
        "伊良部・下地岛区域",
        "系拉・上野区域",
        "平良・北部区域",
        "来间岛区域",
        "与那覇前浜周边区域",
      ],
      한국어: [
        "이라부・시모지섬 지역",
        "시기라・우에노 지역",
        "히라라・북부 지역",
        "쿠리마섬 지역",
        "요나하마에하마 주변 지역",
      ],
    },
    points: [
      {
        title: {
          EN: "Irabu / Shimoji Island Area",
          中文: "伊良部・下地岛区域",
          한국어: "이라부・시모지섬 지역",
        },
        text: {
          EN: "Connected to the main island by Irabu Ohashi Bridge, the Irabu/Shimoji Island area is packed with private-pool villas and high-end resorts. It's close to popular scenic spots like 17END and Sawada-no-hama Beach, making it a favorite for travelers seeking an upscale stay in Miyakojima.",
          中文: "经伊良部大桥与宫古本岛相连的伊良部・下地岛区域，聚集了许多带私人泳池的别墅和高级度假村。周边还有17END、佐和田之滨等热门绝景景点，深受追求高品质住宿体验的旅客欢迎。",
          한국어:
            "이라부대교로 본섬과 이어지는 이라부・시모지섬 지역은 프라이빗 풀이 딸린 빌라와 고급 리조트가 몰려 있는 곳입니다. 17END나 사와다노하마 해변 등 인기 절경 명소와도 가까워, 미야코지마에서 고급스러운 숙박을 원하는 여행자들에게 인기가 많습니다.",
        },
        shops: [
          {
            text: {
              EN: "Opened on Irabu Island in March 2024, this resort stands out with its striking blue-and-white contrast. The terraced, stair-stepped architecture evokes the real Santorini, and the location overlooking Irabu Ohashi Bridge and the sea is another highlight. Higher-tier rooms come with a jacuzzi, and dining is overseen by a well-known chef.",
              中文: "2024年3月在伊良部岛开业的度假村，以醒目的蓝白对比色外观著称。层层叠叠的梯田式建筑让人联想到希腊圣托里尼岛，可眺望伊良部大桥与大海的地理位置也很有魅力。高级客房配备按摩浴缸，还能品尝知名主厨监制的美食。",
              한국어:
                "2024년 3월 이라부섬에 문을 연, 파랑과 하양의 선명한 대비가 눈길을 끄는 리조트입니다. 계단식으로 이어지는 건축은 본고장 산토리니를 연상시키며, 이라부대교와 바다를 조망할 수 있는 입지도 매력입니다. 자쿠지가 딸린 상위 객실과 유명 셰프가 감수한 식사도 즐길 수 있습니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "Approx. ¥35,000–140,000 per room per night (1 guest: approx. ¥35,000–70,000 / 2 guests: approx. ¥50,000–140,000)",
                  中文: "每晚每间约¥35,000～140,000（单人入住：约¥35,000～70,000／两人入住：约¥50,000～140,000）",
                  한국어:
                    "1박 1실 약 ¥35,000~140,000（1인 이용: 약 ¥35,000~70,000 / 2인 이용: 약 ¥50,000~140,000）",
                },
              ],
            ],
          },
          {
            text: {
              EN: 'Standing just across Irabu Ohashi Bridge, this resort is easy to spot thanks to its whitewashed walls and blue domes reminiscent of Santorini. Every villa-type room comes with a private pool and jacuzzi, letting you fully enjoy the blue sea and nature unique to Irabu Island. At the restaurant "Aegean Sea," you can enjoy locally sourced dishes while gazing out at the Miyako blue ocean.',
              中文: "跨过伊良部大桥即可到达，以宛如圣托里尼岛的白色外墙与蓝色圆顶为标志的度假村。别墅式客房均配备私人泳池与按摩浴缸，可尽情享受伊良部岛独有的碧海与自然风光。餐厅「爱琴海」提供地产地消料理，可一边眺望宫古蓝大海一边享用。",
              한국어:
                "이라부대교를 건너면 만나는, 산토리니를 연상시키는 새하얀 외관과 파란 돔이 눈에 띄는 리조트입니다. 빌라 타입 객실은 전 객실에 프라이빗 풀과 자쿠지가 있어, 이라부섬 특유의 푸른 바다와 자연을 만끽할 수 있습니다. 레스토랑 「에게해」에서는 지역 식재료를 사용한 요리를 미야코 블루 바다를 바라보며 즐길 수 있습니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "Approx. ¥38,000 and up (for 2 guests/night, varies by season and plan)",
                  中文: "两人1晚约¥38,000起（价格因季节与方案而异）",
                  한국어: "2인 1박 약 ¥38,000~90,000 이상（시즌・플랜에 따라 변동）",
                },
              ],
            ],
          },
          {
            text: {
              EN: "A quiet all-suite villa on Irabu Island with just 7 rooms. Every room has an ocean-view private pool and kitchen, allowing for a stay that feels like everyday living. French-kaiseki-style meals using Okinawan ingredients, plus breakfast enjoyed while floating in the pool, are also popular.",
              中文: "静立于伊良部岛，仅有7间客房的全套房别墅。每间客房均配备可望海景的私人泳池与厨房，可享受宛如生活般的住宿体验。使用冲绳食材制作的法式怀石风味餐点，以及漂浮在泳池中享用的早餐都深受好评。",
              한국어:
                "이라부섬에 자리한, 단 7개 객실뿐인 올 스위트 빌라입니다. 각 객실에 오션뷰 프라이빗 풀과 주방을 갖추고 있어 마치 생활하듯 머물 수 있습니다. 오키나와 식재료를 사용한 프렌치 가이세키풍 식사와 풀에 떠서 즐기는 조식도 인기입니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "Please check — currently being renovated",
                  中文: "正在装修中，请另行确认",
                  한국어: "리뉴얼 준비 중이므로 확인 필요",
                },
              ],
            ],
          },
          {
            text: {
              EN: "A luxury villa overlooking Irabu Island's deep blue sea, with all 5 rooms offering an ocean view. Each room has its own garden with a hot tub, plus access to a shared kitchen and room service. You can also enjoy a BBQ set prepared by a local Italian bar in Sarahama right in your garden, savoring island flavors like Agu pork and fresh Miyako seafood.",
              中文: "可眺望伊良部岛湛蓝大海的豪华别墅，全5间客房均为海景房。带专属花园的客房配备热水浴缸，还可使用共用厨房与客房服务。也可在庭院中享用当地佐良浜意式酒馆制作的烧烤套餐，尽享阿古猪、宫古鲜鱼等岛屿美味。",
              한국어:
                "이라부섬의 짙푸른 바다를 조망하는, 전 5실 전객실 오션뷰의 럭셔리 빌라입니다. 전용 정원이 딸린 객실에는 히트텁이 완비되어 있으며 공용 주방과 룸서비스도 이용할 수 있습니다. 지역 사라하마의 이탈리안 바가 준비하는 바비큐 세트를 정원에서 즐길 수도 있어, 아구돼지와 미야코 신선 해산물 등 섬의 맛을 만끽할 수 있는 곳입니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "¥100,000–150,000 (for 2 guests/room, breakfast included, estimate)",
                  中文: "¥100,000～150,000（2人1室・含早餐参考价）",
                  한국어: "¥100,000~150,000（2인 1실・조식 포함 기준）",
                },
              ],
            ],
          },
          {
            text: {
              EN: "An all-villa hotel of fully independent units built right on Irabu Island's oceanfront. It features red-tile roofs reminiscent of traditional Ryukyu houses paired with Balinese-style touches, and the spacious terraces command a full view of the Irabu blue horizon. Each room has its own private pool and a red-tile gazebo, letting you relax to the sound of the waves on a terrace surrounded by Ryukyu limestone and tropical plants.",
              中文: "坐落于伊良部岛海滨的全别墅型酒店，各栋均为独立式建筑。以琉球古民居风格的红瓦屋顶搭配巴厘岛式装饰为特色，宽敞的露台可将伊良部蓝的海平线尽收眼底。每间客房均配有专属私人泳池与红瓦凉亭，可在被琉球石灰岩与南国植物环绕的露台上，伴着波涛声悠然度过。",
              한국어:
                "이라부섬 오션프런트에 자리한, 전 동이 독립형인 올 빌라 호텔입니다. 류큐 전통 가옥을 연상시키는 붉은 기와와 발리풍 인테리어가 특징이며, 널찍한 테라스에서는 이라부 블루의 수평선을 한눈에 담을 수 있습니다. 각 객실 전용 프라이빗 풀과 붉은 기와 가제보를 갖추고 있어, 류큐 석회암과 남국 식물에 둘러싸인 테라스에서 파도 소리와 함께 여유롭게 지낼 수 있습니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "¥62,000–120,000 (for 2 guests/room)",
                  中文: "¥62,000～120,000（2人1室）",
                  한국어: "¥62,000~120,000（2인 1실）",
                },
              ],
            ],
          },
          {
            text: {
              EN: 'A whole-villa rental in a vacation-house style, built on the beachfront overlooking Sawada-no-hama, one of Japan\'s 100 Best Beaches. There are 8 villas plus a separate annex called "~Hanare~," each with a highly private heated pool. You can enjoy a stay with the feel of a private vacation home, quite different from a hotel, while watching a beautiful sunset.',
              中文: "坐落于日本渚百选之一「佐和田之滨」海滨的别墅风整栋出租villa。共有8栋别墅及别馆「〜离れ〜」，每栋均配备私密性极高的温水泳池。可一边欣赏美丽的日落，一边体验与酒店截然不同的别墅式住宿。",
              한국어:
                "일본 나기사 100선 「사와다노하마」를 바라보는 비치프런트에 자리한, 별장 스타일의 통대여 빌라입니다. 총 8동의 빌라와 별채 「~하나레~」가 있으며, 모든 동에 프라이버시가 높은 온수 풀을 완비하고 있습니다. 아름다운 석양을 바라보며 호텔과는 또 다른 별장 같은 느낌의 숙박을 즐길 수 있습니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "¥48,000–90,000 (for 2 guests/room)",
                  中文: "¥48,000～90,000（2人1室）",
                  한국어: "¥48,000~90,000（2인 1실）",
                },
              ],
            ],
          },
          {
            text: {
              EN: "A 58-room resort on the coast of Irabu Island, part of Marriott's Luxury Collection. It's conveniently located about 3 minutes by car from Irabu Ohashi Bridge and about 5 minutes from Sawada-no-hama Beach. With bright, white-toned rooms, an infinity pool that seems to merge with the sea, a spa offering massages and facials, and a fitness center, you can enjoy an extraordinary stay amid quiet surroundings. Choose between rooms with balcony ocean views or ground-floor garden-view rooms with a private pool.",
              中文: "坐落于伊良部岛海岸边，隶属万豪奢华精选（Luxury Collection）品牌的58间客房度假村。距伊良部大桥车程约3分钟，距佐和田之滨约5分钟，交通便利。以白色为基调的开阔客房、仿佛与大海融为一体的无边泳池、可享受按摩与美容护理的水疗中心，以及健身中心一应俱全，让您在宁静中体验非日常的度假时光。设有阳台可眺望海景的客房，以及一楼配备私人泳池的花园景观客房。",
              한국어:
                "이라부섬 해안가에 위치한, 메리어트 럭셔리 컬렉션 소속 전 58실 리조트입니다. 이라부대교까지 차로 약 3분, 사와다노하마까지 약 5분으로 접근성도 좋습니다. 화이트 톤의 개방적인 객실, 바다와 하나가 되는 듯한 인피니티 풀, 마사지와 페이셜을 받을 수 있는 스파, 피트니스 센터 등을 갖추어 조용함 속에서 특별한 시간을 보낼 수 있습니다. 발코니에서 오션뷰를 즐길 수 있는 객실과, 1층의 프라이빗 풀이 딸린 가든뷰 객실이 있습니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "¥54,000–150,000 (for 2 guests/room)",
                  中文: "¥54,000～150,000（2人1室）",
                  한국어: "¥54,000~150,000（2인 1실）",
                },
              ],
            ],
          },
          {
            text: {
              EN: "A luxury resort on Irabu Island, just across Irabu Ohashi Bridge, where every room is a suite. Each room comes with a private pool, an outdoor jacuzzi, and a free rental car for guests, letting you enjoy an exquisite private space overlooking the Miyako-blue sea. With its quiet, small-scale setting, it's also a great choice for an anniversary trip with someone special.",
              中文: "位于跨过伊良部大桥后的伊良部岛，全客房均为套房的豪华度假村。每间客房均配备私人泳池、室外按摩浴缸及住客专用免费租车服务，可在可眺望宫古蓝大海的极致私密空间中度过。客房数量少带来的静谧感，也很适合与重要的人一同度过纪念日旅行。",
              한국어:
                "이라부대교를 건넌 이라부섬에 자리한, 전 객실이 스위트룸인 럭셔리 리조트입니다. 전 객실에 프라이빗 풀과 야외 자쿠지, 투숙객 전용 무료 렌터카를 완비하여 미야코 블루 바다를 바라보는 최고의 프라이빗 공간에서 지낼 수 있습니다. 객실 수가 적어 조용하기 때문에 소중한 사람과의 기념일 여행에도 추천합니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "¥109,000–200,000 (for 2 guests/room)",
                  中文: "¥109,000～200,000（2人1室）",
                  한국어: "¥109,000~200,000（2인 1실）",
                },
              ],
            ],
          },
        ],
      },
      {
        title: {
          EN: "Shigira / Ueno Area",
          中文: "系拉・上野区域",
          한국어: "시기라・우에노 지역",
        },
        text: {
          EN: "This stretch runs from the Shigira Seven Mile Resort in southern Miyakojima through to the Ueno area. It offers both large resorts packed with restaurants and activity facilities, and hideaway whole-villa rentals, with easy access to popular beaches like Aragusuku Beach.",
          中文: "从宫古岛南部的「系拉七英里度假区」延伸至上野地区一带。这里既有汇聚餐厅与休闲设施的大型度假村，也有隐世风格的整栋出租别墅，还能轻松前往新城海岸等人气海滩。",
          한국어:
            "미야코지마 남부에 펼쳐진 「시기라 세븐마일즈 리조트」에서 우에노 지역에 걸친 일대입니다. 레스토랑과 액티비티 시설이 모인 대형 리조트와 은신처 같은 통대여 빌라가 모두 갖춰져 있으며, 아라구스쿠 해변 등 인기 해변으로도 접근이 좋은 지역입니다.",
        },
        shops: [
          {
            text: {
              EN: 'A high-class resort set within the "Shigira Seven Mile Resort," a roughly 4.3-million-square-meter resort city on Miyakojima\'s southern coast. Choose between the "Bayside" wing close to the sea and the "Pool Villa Premier" wing on a small hill. Besides the pool in front of the hotel, you can also use the on-site Shigira Garden Pool, beachside pool, and private cabanas, plus a hot spring with naturally flowing source water and spa treatment facilities. Pet-friendly rooms are also available.',
              中文: "坐落于宫古岛南岸，占地约130万坪的度假城「系拉七英里度假区」内的高级度假村。可从近海的「海滨（Bayside）」栋与建于小丘上的「泳池别墅尊享（Pool Villa Premier）」栋两种类型中选择。除酒店前的泳池外，还可使用园区内的系拉花园泳池、海滨泳池及私人凉亭，并配有源泉放流式温泉与美容护理设施。同时也提供可携宠物入住的客房。",
              한국어:
                "미야코지마 남쪽 해안, 약 130만 평 규모의 리조트 시티 「시기라 세븐마일즈 리조트」 안에 자리한 고급 리조트입니다. 바다에 가까운 「베이사이드」동과 작은 언덕에 위치한 「풀빌라 프리미어」동, 두 타입 중 선택할 수 있습니다. 호텔 앞 풀 외에도 부지 내 시기라 가든풀과 비치사이드풀, 프라이빗 카바나를 이용할 수 있으며, 원천 온천과 에스테틱 시설도 완비되어 있습니다. 반려동물과 함께 묵을 수 있는 객실도 마련되어 있습니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "¥41,000–140,000 (for 2 guests/room, breakfast included, estimate)",
                  中文: "¥41,000～140,000（2人1室・含早餐参考价）",
                  한국어: "¥41,000~140,000（2인 1실・조식 포함 기준）",
                },
              ],
            ],
          },
          {
            text: {
              EN: 'An all-suite hotel with 174 rooms inside the Shigira Seven Mile Resort. Its charm lies in the tropical mood of the property, filled with blooming flowers, and you can also choose the "Pool Villa Lagoon Suite," which comes with a private pool. Pet-friendly rooms are available as well.',
              中文: "位于系拉七英里度假区内，全174间客房均为套房的酒店。馆内繁花盛开、南国氛围浓郁是其一大魅力，还可选择配有私人泳池的「泳池别墅泻湖套房」。此外也备有可携宠物入住的客房。",
              한국어:
                "시기라 세븐마일즈 리조트 안에 있는, 전 174실 올 스위트 호텔입니다. 꽃이 만발한 남국 분위기 가득한 시설이 매력이며, 프라이빗 풀이 딸린 「풀빌라 라군 스위트」도 선택할 수 있습니다. 반려동물과 함께 묵을 수 있는 객실이 마련되어 있는 것도 포인트입니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "¥24,000–90,000 (for 2 guests/room)",
                  中文: "¥24,000～90,000（2人1室）",
                  한국어: "¥24,000~90,000（2인 1실）",
                },
              ],
            ],
          },
          {
            text: {
              EN: "Red-tile private cottages lined up facing Miyako's blue sea. Every room's terrace has a jacuzzi bath, and the loft-equipped cottages let you stay as if you were living there. The restaurant within the village serves a Miyako-style buffet using island ingredients, and the view from the pool overlooking the East China Sea is nothing short of paradise. It's an open, relaxed stay that feels like visiting a private vacation home.",
              中文: "面朝宫古蓝海排列的红瓦私人小屋。每间客房的露台均设有按摩浴缸，配备阁楼的小屋让人仿佛在此生活般度假。村内餐厅可享用使用岛屿食材制作的宫古风味自助餐，从可眺望东海的泳池望去的景色宛如天堂。可享受宛如造访别墅般的开阔住宿体验。",
              한국어:
                "미야코의 푸른 바다를 마주보고 늘어선 붉은 기와 프라이빗 코티지입니다. 모든 객실 테라스에 자쿠지 욕조가 있으며, 다락방을 갖춘 코티지에서 마치 생활하듯 머물 수 있습니다. 빌리지 내 레스토랑에서는 섬 식재료를 사용한 미야코 스타일 뷔페를 즐길 수 있고, 동중국해를 한눈에 담는 풀에서의 경치는 그야말로 낙원입니다. 별장을 방문한 듯한 개방적인 숙박을 즐길 수 있습니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "¥30,000–45,000 (for 2 guests/room)",
                  中文: "¥30,000～45,000（2人1室）",
                  한국어: "¥30,000~45,000（2인 1실）",
                },
              ],
            ],
          },
          {
            text: {
              EN: 'A whole-villa rental made up of a main building and an annex, set on a lush green hilltop in Miyakojima. The main building sleeps up to 7 and the annex up to 5, and every room offers an ocean view. It\'s about a 5-minute walk to the calm "Ingya Marine Garden," making it well suited for long stays with family or groups.',
              中文: "坐落于宫古岛绿意盎然高地上的整栋出租别墅，由本馆与别馆两栋组成。本馆最多可住7人，别馆最多可住5人，所有房间均可欣赏海景。步行约5分钟即可到达平静的「因加海洋花园」，非常适合家庭或团体长期入住。",
              한국어:
                "미야코지마의 녹음이 우거진 고지대에 자리한, 본관・별관 2동으로 이루어진 통대여 빌라입니다. 본관은 최대 7명, 별관은 최대 5명까지 숙박 가능하며 어느 방에서든 오션뷰를 즐길 수 있습니다. 잔잔한 「인갸 마린가든」까지 도보 약 5분 거리로, 가족이나 그룹의 장기 체류에도 적합합니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "¥40,000–70,000 (for 2 guests/room)",
                  中文: "¥40,000～70,000（2人1室）",
                  한국어: "¥40,000~70,000（2인 1실）",
                },
              ],
            ],
          },
          {
            text: {
              EN: "About 15 minutes by car from Miyako Airport, this whole-villa private rental sits along the coast in the Ueno area. Every room has a heated private pool that can be enjoyed year-round. The terrace and garden views are lovely, and a BBQ grill plus local tour and ticket booking assistance are also available. With few streetlights around, the night sky fills with stars.",
              中文: "距宫古机场车程约15分钟，坐落于上野地区海边的整栋出租私人别墅。所有客房均配备温水私人泳池，无论季节均可尽情享受。露台与庭院景观也十分怡人，还可使用烧烤炉及当地旅游・门票预约向导服务。周边路灯稀少，夜晚可欣赏满天繁星。",
              한국어:
                "미야코 공항에서 차로 약 15분, 우에노 지역 해안가에 자리한 통대여 프라이빗 빌라입니다. 전 객실에 온수 프라이빗 풀을 갖추고 있어 계절에 상관없이 즐길 수 있습니다. 테라스와 정원에서의 전망도 좋고, BBQ 그릴과 현지 투어・티켓 안내 서비스도 이용할 수 있습니다. 가로등이 적은 입지라 밤에는 별이 가득한 하늘도 즐길 수 있습니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "¥47,000–90,000 (for 2 guests/room)",
                  中文: "¥47,000～90,000（2人1室）",
                  한국어: "¥47,000~90,000（2인 1실）",
                },
              ],
            ],
          },
        ],
      },
      {
        title: {
          EN: "Hirara / North Area",
          中文: "平良・北部区域",
          한국어: "히라라・북부 지역",
        },
        text: {
          EN: "The northern Miyakojima area stretching from Hirara, home to the island's downtown, out to Sunset Beach and Oura Bay. It's well connected to the airport and offers everything from large resorts to buzzy new luxury hotels.",
          中文: "从拥有宫古岛市区的平良，一直延伸至日落海滩与大浦湾的宫古岛北部区域。距机场交通便利，从大型度假村到话题新开的豪华酒店应有尽有。",
          한국어:
            "미야코지마의 시가지가 있는 히라라에서 선셋비치, 오우라만에 이르는 미야코지마 북부 지역입니다. 공항에서의 접근성이 좋으며, 대형 리조트부터 화제의 신규 럭셔리 호텔까지 다양하게 갖춰져 있습니다.",
        },
        shops: [
          {
            text: {
              EN: 'Opened in March 2025 on a cape overlooking Oura Bay in northern Miyakojima, this is Rosewood Hotels & Resorts\' first property in Japan. Spread across roughly 95,000 square meters, all 55 buildings are independent villas with an ocean view and private pool — a truly luxurious layout. The architecture incorporating Ryukyu limestone is also a highlight, offering an extraordinary experience befitting an international luxury brand.',
              中文: "2025年3月于宫古岛北部、可眺望大浦湾的海角上诞生的「柏悦（Rosewood）酒店与度假村」日本首家门店。占地约9.5万平方米，全55栋均为带海景与私人泳池的独立别墅，造型极尽奢华。融入琉球石灰岩元素的建筑也是一大看点，可体验国际豪华品牌独有的非凡感受。",
              한국어:
                "2025년 3월, 미야코지마 북부 오우라만을 조망하는 곶에 문을 연 「로즈우드 호텔＆리조트」 일본 1호점입니다. 약 9만 5,000㎡ 부지에 전 55동 모두 오션뷰＆프라이빗 풀이 딸린 독립 빌라라는 호화로운 구성입니다. 류큐 석회암을 활용한 건축도 볼거리이며, 국제적인 럭셔리 브랜드만의 비일상적 경험을 할 수 있습니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "¥200,000–400,000 (for 2 guests/room, ultra-luxury range estimate)",
                  中文: "¥200,000～400,000（2人1室・超高级价位参考）",
                  한국어: "¥200,000~400,000（2인 1실・초고급 등급 기준）",
                },
              ],
            ],
          },
          {
            text: {
              EN: "A large resort hotel in Hirara, Miyakojima City, right next to Miyako Sunset Beach. Overlooking Irabu Ohashi Bridge and the Miyako-blue sea, it offers a full range of facilities including 5 indoor and outdoor pools, a spa, and a kids club. About 15 minutes by car from Miyako Airport, it's also a convenient base for a first trip to Miyakojima.",
              中文: "位于宫古岛市平良、毗邻宫古日落海滩的大型度假酒店。可眺望伊良部大桥与宫古蓝大海的地理位置，馆内设施十分完善，室内外合计设有5个泳池、水疗中心及儿童俱乐部。距宫古机场车程约15分钟，对初次前往宫古岛旅行的游客也十分便利。",
              한국어:
                "미야코지마시 히라라, 미야코 선셋비치에 인접한 대형 리조트 호텔입니다. 이라부대교와 미야코 블루 바다를 조망할 수 있는 입지로, 실내외 합계 5개의 풀과 스파, 키즈클럽까지 시설이 충실합니다. 미야코 공항에서 차로 약 15분 거리로, 처음 미야코지마를 여행하는 경우에도 편리한 입지입니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "¥33,000–120,000 (for 2 guests/room)",
                  中文: "¥33,000～120,000（2人1室）",
                  한국어: "¥33,000~120,000（2인 1실）",
                },
              ],
            ],
          },
          {
            text: {
              EN: 'Like the neighboring Hilton, this hotel from the designer brand "Canopy" sits right by Sunset Beach. Its interiors are known for reflecting the local atmosphere, and at the end of the day you can take in stunning views of Irabu Ohashi Bridge and the Miyako-blue sea from the 12th-floor rooftop pool and bar.',
              中文: "与希尔顿同样毗邻日落海滩，隶属设计师品牌「Canopy」的酒店。以融入当地氛围的室内设计为特色，一天结束时可在12楼的屋顶泳池与酒吧欣赏伊良部大桥与宫古蓝的绝美景色。",
              한국어:
                "힐튼과 마찬가지로 선셋비치에 인접한, 디자이너 브랜드 「Canopy」의 호텔입니다. 지역 분위기를 반영한 인테리어가 특징이며, 하루를 마무리할 때 12층 루프톱 풀＆바에서 이라부대교와 미야코 블루의 절경을 즐길 수 있습니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "Recently opened — please check for current rates",
                  中文: "开业不久，请另行确认价格",
                  한국어: "개업한 지 얼마 안 되어 확인 필요",
                },
              ],
            ],
          },
          {
            text: {
              EN: 'A private villa in northern Miyakojima produced by the Gamin Group, which runs restaurants and patisseries in Tokyo. Built around the concept of "fine dining and quality sleep," all three room types come with a private pool. It\'s also conveniently located, about 15 minutes by car from Miyako Airport.',
              中文: "由在东京经营餐厅与甜品店的Gamin集团打造的宫古岛北部私人别墅。以「美食与优质睡眠」为理念，三种客房类型均配备私人泳池。距宫古机场车程约15分钟，交通便利。",
              한국어:
                "도쿄에서 레스토랑과 파티스리를 운영하는 갸맹 그룹이 프로듀스한 미야코지마 북부의 프라이빗 빌라입니다. 「미식과 양질의 수면」을 콘셉트로, 3가지 타입의 객실 모두에 프라이빗 풀을 완비하고 있습니다. 미야코 공항에서 차로 약 15분으로 접근성도 좋습니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "¥132,000–200,000 (for 2 guests, dinner and breakfast included, estimate)",
                  中文: "¥132,000～200,000（2人・含晚餐及早餐参考价）",
                  한국어: "¥132,000~200,000（2인・조식·석식 포함 기준）",
                },
              ],
            ],
          },
        ],
      },
      {
        title: {
          EN: "Kurima Island Area",
          中文: "来间岛区域",
          한국어: "쿠리마섬 지역",
        },
        text: {
          EN: "Kurima Island, connected to the main island by Kurima Ohashi Bridge, is known for its hilltop views over Yonaha Maehama Beach and its peaceful scenery. It's a great pick for travelers wanting to get away from the crowds and relax quietly.",
          中文: "由来间大桥与本岛相连的来间岛，魅力在于可俯瞰与那覇前浜的高地与恬静的景色。适合想远离喧嚣、安静度假的旅程。",
          한국어:
            "쿠리마대교로 본섬과 이어지는 쿠리마섬은 요나하마에하마를 한눈에 담을 수 있는 고지대와 한적한 풍경이 매력인 지역입니다. 번잡함에서 벗어나 조용히 지내고 싶은 여행에 추천합니다.",
        },
        shops: [
          {
            text: {
              EN: 'A resort hotel spread along the northern shore of Kurima Island, just across Kurima Ohashi Bridge. Made up of 169 units designed to evoke traditional Okinawan homes, you can choose between the "Villa House," with a private pool and jacuzzi, and the "Shuri House," which incorporates Ryukyu style. The property has two restaurants, including a French one, and its ideal location — also known as a sunset spot — lets you enjoy the sunset amid clear Miyako-blue water and a tropical mood.',
              中文: "跨过来间大桥后，坐落于来间岛北岸的度假酒店。全169栋以冲绳民居为设计理念，可从配有私人泳池与按摩浴缸的「别墅屋（Villa House）」和融入琉球风格的「首里屋（Shuri House）」两种类型中选择。馆内设有包括法餐厅在内的两家餐厅，作为知名的日落景点，可在澄澈的宫古蓝海水与南国氛围中欣赏日落美景。",
              한국어:
                "쿠리마대교를 건넌 곳, 쿠리마섬 북쪽 해안에 펼쳐진 리조트 호텔입니다. 오키나와 전통 가옥을 이미지한 전 169동으로, 프라이빗 풀과 자쿠지가 딸린 「빌라 하우스」와 류큐 양식을 도입한 「슈리 하우스」 2가지 타입 중 선택할 수 있습니다. 시설 내에는 프렌치를 포함한 2개의 레스토랑이 있으며, 석양 명소로도 알려진 최적의 입지에서 맑은 미야코 블루 바다와 트로피컬한 분위기 속에서 일몰도 즐길 수 있습니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "¥22,400–60,000 (for 2 guests/room)",
                  中文: "¥22,400～60,000（2人1室）",
                  한국어: "¥22,400~60,000（2인 1실）",
                },
              ],
            ],
          },
        ],
      },
      {
        title: {
          EN: "Yonaha Maehama Area",
          中文: "与那覇前浜周边区域",
          한국어: "요나하마에하마 주변 지역",
        },
        text: {
          EN: 'The area around "Yonaha Maehama," a white-sand beach often called the finest in the East, extending toward Ikema Island. It has many whole-villa private rentals, making it well suited for travelers who want to relax without worrying about anyone else around.',
          中文: "从被誉为东洋第一白沙滩的「与那覇前浜」周边延伸至池间岛方向的区域。整栋出租型私人别墅较多，适合不想在意周围目光、悠闲度过的旅行。",
          한국어:
            "동양 제일이라고도 불리는 하얀 모래사장 「요나하마에하마」 주변에서 이케마섬 방면에 걸친 지역입니다. 통대여 프라이빗 빌라가 많아, 주변을 신경 쓰지 않고 지내고 싶은 여행에 적합합니다.",
        },
        shops: [
          {
            text: {
              EN: 'A fully independent whole-villa property overlooking Yonaha Bay, unlike anything else on Miyakojima. It rebranded and reopened in May 2024, hosting just one group of up to 6 guests per day in a single freestanding building with 2 rooms, not connected to any other unit. Surrounded by a sense of openness as if wrapped in the milky-blue sea, you can relax in the pool, which is usable year-round.',
              中文: "面朝与那覇湾，宫古岛独一无二的完全独立式整栋别墅。2024年5月焕新重开，每日限定1组、最多6人入住，独享不与邻栋相连的1栋2房。在仿佛被乳蓝色大海包裹般的开阔感中，可在全年皆宜使用的泳池悠然度过。",
              한국어:
                "요나하만을 바라보는, 미야코지마에서 이곳뿐인 완전 독립형 통대여 빌라입니다. 2024년 5월 리브랜드 오픈하여, 하루 1팀・최대 6명 한정으로 옆과 연결되지 않은 독립된 1동 2개 객실만을 전체 대여합니다. 밀키 블루 바다에 감싸인 듯한 개방감 속에서, 연중 이용 가능한 풀에서 여유롭게 지낼 수 있습니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "¥94,000–150,000 (for 2 guests/room)",
                  中文: "¥94,000～150,000（2人1室）",
                  한국어: "¥94,000~150,000（2인 1실）",
                },
              ],
            ],
          },
          {
            text: {
              EN: 'A private villa limited to just 3 groups per day, with every building fully independent. Each unit is about 76 square meters indoors, exceeding 100 square meters including the terrace, and comes with a 24-hour heated pool and a full kitchen. Another highlight is the free "car service" included with each room, letting you enjoy sightseeing around Miyakojima without arranging a rental car.',
              中文: "每日限定3组入住，各栋均为独立式的私人别墅。室内约76平方米，加上露台超过100平方米，配备24小时可用的温水泳池与系统厨房。每间客房均附带一辆免费「用车服务」也是一大魅力，无需另行安排租车即可畅游宫古岛。",
              한국어:
                "하루 3팀 한정, 전 동이 독립된 프라이빗 빌라입니다. 실내 약 76㎡, 테라스를 포함하면 100㎡를 넘는 넓이로, 24시간 이용 가능한 온수 풀과 시스템 키친을 완비하고 있습니다. 객실당 1대 무료 「카 서비스」가 포함되어 있는 것도 매력으로, 렌터카를 따로 준비하지 않아도 미야코지마 관광을 즐길 수 있습니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "¥49,000–100,000 (for 2 guests/room)",
                  中文: "¥49,000～100,000（2人1室）",
                  한국어: "¥49,000~100,000（2인 1실）",
                },
              ],
            ],
          },
          {
            text: {
              EN: "A private vacation house limited to one group per day, set on a hilltop in Miyakojima with a sweeping ocean view. It's well equipped with water features like an outdoor pool, an outdoor bath, and a jacuzzi, plus a game room and karaoke, letting you enjoy exquisite private time without worrying about anyone else around.",
              中文: "坐落于宫古岛高地，可眺望壮阔海景、每日限定1组入住的独栋别墅。室外泳池、露天风吕、按摩浴缸等水疗设施一应俱全，还配备游戏室与卡拉OK，可在不受任何人打扰的情况下享受极致的私人时光。",
              한국어:
                "미야코지마의 고지대에 펼쳐진, 웅장한 오션뷰를 자랑하는 하루 1팀 한정 대여 별장입니다. 야외 풀과 노천탕, 자쿠지 등 물 관련 시설이 충실할 뿐 아니라 게임룸과 노래방도 갖추고 있어, 누구의 시선도 신경 쓰지 않고 최고의 프라이빗한 시간을 보낼 수 있습니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "¥49,000–90,000 (for 2 guests/room)",
                  中文: "¥49,000～90,000（2人1室）",
                  한국어: "¥49,000~90,000（2인 1실）",
                },
              ],
            ],
          },
          {
            text: {
              EN: "A whole-villa rental made up of just two buildings — a pool house and a sauna house. The pool house has a 9-meter heated private pool, said to be one of the largest on Miyakojima, and it's lit up until midnight for a dreamlike atmosphere. The sauna house is a serious setup with temperature control in 0.5-degree increments and a chiller-cooled cold plunge, satisfying even dedicated sauna fans.",
              中文: "由泳池栋与桑拿栋两栋组成的整栋出租别墅。泳池栋设有据称是宫古岛最大级、全长9米的温水私人泳池，夜间点灯至24点，营造梦幻氛围。桑拿栋则采用可以0.5度为单位调节温度的专业规格，并配有带制冷设备的冷水池，即便是桑拿爱好者也能感到满意的设施。",
              한국어:
                "풀동과 사우나동, 단 2개 동으로 이루어진 통대여 빌라입니다. 풀동에는 미야코지마 최대급이라는 전장 9m의 온수 프라이빗 풀이 있으며, 밤 24시까지 조명이 켜져 몽환적인 분위기도 즐길 수 있습니다. 사우나동은 0.5도 단위로 온도 조절이 가능한 본격 사양으로, 칠러가 딸린 냉수풀도 있어 사우나 애호가도 만족할 수 있는 시설입니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "¥48,000–90,000 (for 2 guests/room)",
                  中文: "¥48,000～90,000（2人1室）",
                  한국어: "¥48,000~90,000（2인 1실）",
                },
              ],
            ],
          },
          {
            text: {
              EN: 'A sophisticated hideaway resort on Miyakojima\'s quiet east coast. Every room is an independent villa/cottage, and each terrace comes with a private pool. Activities that enrich your stay are also on offer, such as bath salts you can blend yourself from rock salt and herbs, and a "marshmallow night" spent on the terrace, making it a great fit for everything from a couple\'s getaway to a family beach stay, spent close to Miyakojima\'s nature.',
              中文: "静立于宫古岛宁静东海岸的成人隐世度假村。所有客房均为独立别墅・小屋，露台配备私人泳池。还准备了可自行调配岩盐与香草的沐浴盐、以及在露台度过的棉花糖之夜等丰富住宿体验活动，无论是两人旅行还是家庭海滩之旅，都能在贴近宫古自然的时光中度过。",
              한국어:
                "미야코지마의 조용한 동해안에 자리한 어른들을 위한 은신처 리조트입니다. 객실은 모두 독립된 빌라・코티지이며, 테라스에는 프라이빗 풀을 완비하고 있습니다. 암염과 허브를 취향대로 블렌딩할 수 있는 배스솔트, 테라스에서 보내는 마시멜로 나이트 등 체류를 풍성하게 하는 액티비티도 준비되어 있어, 커플 여행부터 가족 비치 스테이까지 미야코의 자연에 다가서는 듯한 시간을 보낼 수 있습니다.",
            },
            rows: [
              [
                undefined,
                {
                  EN: "¥39,000–60,000 (for 2 guests/room)",
                  中文: "¥39,000～60,000（2人1室）",
                  한국어: "¥39,000~60,000（2인 1실）",
                },
              ],
            ],
          },
        ],
      },
    ],
  },
  "miyakojima-girls-trip-spots": {
    title: {
      EN: "Recommended Girls Trip Spots Around Miyakojima",
      中文: "宫古岛周边女生旅行推荐景点",
      한국어: "미야코지마 주변 여자 여행 추천 스팟",
    },
    text: {
      EN: "Beaches, bridges, cafés, sunsets, and hidden SUP spots for a photogenic girls trip.",
      中文: "适合女生旅行拍照的海滩、大桥、咖啡、夕阳和秘境SUP地点。",
      한국어: "여자 여행에 좋은 해변, 다리, 카페, 선셋, 비경 SUP 스팟.",
    },
    description: {
      EN: "A guide to girls-trip spots around Miyakojima, including beaches, bridges, cafés, sunset spots, hidden SUP, and photo locations.",
      中文: "介绍宫古岛女生旅行想去的海滩、大桥、咖啡、夕阳、秘境SUP和拍照地点。",
      한국어:
        "미야코지마 여자 여행에서 가고 싶은 해변, 다리, 카페, 선셋, 비경 SUP, 촬영 스팟을 소개합니다.",
    },
    leadText: {
      EN: "Miyakojima has many spots that fit a girls trip: blue bridges, photogenic beaches, tropical cafés, sunset views, and quiet hidden experiences.",
      中文: "宫古岛有很多适合女生旅行的地方，比如蓝色大桥、适合拍照的海滩、南国咖啡、夕阳和安静秘境体验。",
      한국어:
        "미야코지마에는 푸른 다리, 사진 좋은 해변, 남국 카페, 선셋, 조용한 비경 체험 등 여자 여행에 어울리는 장소가 많습니다.",
    },
    toc: {
      EN: [
        "Blue bridges and beaches",
        "Photogenic cafés",
        "Sunset spots",
        "Hidden SUP spots",
      ],
      中文: ["宫古蓝大桥和海滩", "适合拍照的咖啡", "夕阳景点", "秘境SUP地点"],
      한국어: [
        "미야코 블루 다리와 해변",
        "사진 찍고 싶은 카페",
        "선셋 스팟",
        "비경 SUP 스팟",
      ],
    },
  },
  "girls-trip-photo-movie-miyakojima": {
    title: {
      EN: "Photos and Videos to Capture on a Miyakojima Girls Trip",
      中文: "宫古岛女生旅行一定要留下的照片与影片",
      한국어: "미야코지마 여자여행에서 꼭 남기고 싶은 사진과 영상",
    },
    text: {
      EN: "See the actual kinds of ocean photos, SUP scenes, drone footage, secret beach portraits, and short movies you can capture on a Miyakojima girls trip.",
      中文: "介绍宫古岛女生旅行中可以拍到的海景照片、SUP画面、无人机影像、秘密海滩写真和短片。",
      한국어:
        "미야코지마 여자여행에서 남길 수 있는 바다 사진, SUP 장면, 드론 영상, 시크릿 비치 포트레이트, 숏폼 영상을 소개합니다.",
    },
    description: {
      EN: "A visual guide to the photos and videos you can capture in Miyakojima, from blue ocean portraits and hidden SUP scenes to drone footage and cinematic travel movies.",
      中文: "介绍在宫古岛可以拍到的照片与影片，包括宫古蓝人像、秘境SUP、无人机影像和旅行短片。",
      한국어:
        "미야코지마에서 남길 수 있는 사진과 영상을 소개하는 가이드입니다. 미야코 블루 포트레이트, 비경 SUP, 드론 영상, 여행 무비까지 정리했습니다.",
    },
    leadText: {
      EN: "On a Miyakojima girls trip, the best memories are not just scenery photos. They are photos and videos that bring back the mood, the laughter, and the ocean breeze. Here are the actual types of shots you can capture on the hidden photo tour and hidden SUP experience.",
      中文: "宫古岛女生旅行最想留下的，不只是风景照片，而是能想起当时空气、笑声和海风的照片与影片。这里介绍秘境摄影行程和秘境SUP中实际可以拍到的画面。",
      한국어:
        "미야코지마 여자여행에서 가장 남기고 싶은 것은 단순한 풍경 사진이 아니라 그때의 분위기와 웃음, 바람까지 떠오르는 사진과 영상입니다. 비경 포토 투어와 비경 SUP에서 실제로 남길 수 있는 컷을 소개합니다.",
    },
    toc: {
      EN: [
        "Blue ocean portraits",
        "Drone footage from above",
        "Hidden SUP shots",
        "Natural portraits on secret beaches",
        "Short movies that capture the trip mood",
        "Special sunset and starry-sky shots",
      ],
      中文: [
        "宫古蓝海景写真",
        "从空中留下的无人机影像",
        "SUP才能抵达的秘境画面",
        "秘密海滩上的自然写真",
        "留下旅行氛围的短片",
        "夕阳与星空下的特别照片",
      ],
      한국어: [
        "미야코 블루 바다 사진",
        "하늘에서 남기는 드론 영상",
        "SUP로만 갈 수 있는 비경 컷",
        "시크릿 비치의 자연스러운 사진",
        "여행 분위기를 담는 숏무비",
        "선셋과 별하늘의 특별한 한 장",
      ],
    },
    cta: {
      title: {
        EN: "A Hidden Photo Tour for Photos and Videos You Will Want to Share",
        中文: "留下想分享到SNS的照片与影片的秘境摄影行程",
        한국어: "SNS에 올리고 싶은 사진과 영상을 남기는 비경 포토 투어",
      },
      text: {
        EN: "A private tour to hidden spots and quiet beaches, including photos, videos, and drone shooting.",
        中文: "一组限定的私人行程，前往秘境与安静海滩，包含照片、影片和无人机拍摄。",
        한국어:
          "숨은 명소와 조용한 해변으로 안내하며 사진, 영상, 드론 촬영까지 포함된 프라이빗 투어입니다.",
      },
      buttonText: {
        EN: "View the Hidden Photo Tour",
        中文: "查看秘境摄影行程",
        한국어: "비경 포토 투어 보기",
      },
    },
    points: [
      {
        title: {
          EN: "Blue ocean portraits",
          中文: "宫古蓝海景写真",
          한국어: "미야코 블루 바다 사진",
        },
        area: {
          EN: "Blue Ocean Photo",
          中文: "宫古蓝写真",
          한국어: "블루 오션 포토",
        },
        text: {
          EN: "We capture natural walking shots, looking-back moments, and smiles with Miyakojima's clear blue ocean in the background. The photos feel effortless, but still show the beauty of the island.",
          中文: "以透明的宫古蓝大海为背景，拍下自然走路、回头、朋友一起笑的瞬间。不需要刻意摆拍，也能留下很有宫古岛感觉的照片。",
          한국어:
            "투명한 미야코 블루 바다를 배경으로 걷는 모습, 뒤돌아보는 순간, 친구들과 웃는 자연스러운 장면을 촬영합니다. 과하지 않지만 미야코지마다운 사진이 남습니다.",
        },
      },
      {
        title: {
          EN: "Drone footage from above",
          中文: "从空中留下的无人机影像",
          한국어: "하늘에서 남기는 드론 영상",
        },
        area: { EN: "Drone Movie", 中文: "无人机影像", 한국어: "드론 무비" },
        text: {
          EN: "From above, we capture the ocean gradients, white sand, and the scale of Miyakojima. When people appear small in the frame, the private feeling and size of the ocean come through.",
          中文: "从空中拍摄海的渐层、白色沙滩和宫古岛的开阔感。人物在画面中变小，反而更能表现大海的辽阔和私人感。",
          한국어:
            "하늘에서 바다의 그라데이션, 하얀 모래, 미야코지마의 스케일을 담습니다. 사람이 작게 보일수록 바다의 넓이와 프라이빗한 분위기가 더 잘 전해집니다.",
        },
      },
      {
        title: {
          EN: "Hidden SUP shots",
          中文: "SUP才能抵达的秘境画面",
          한국어: "SUP로만 갈 수 있는 비경 컷",
        },
        area: { EN: "Hidden SUP", 中文: "秘境SUP", 한국어: "비경 SUP" },
        text: {
          EN: "We shoot in quiet places that are reachable because you move across the ocean by SUP. Sitting on the board, floating above clear water, and relaxing on the ocean all create a different look from regular beach photos.",
          中文: "因为划SUP从海上前往，才能到达安静的秘境。坐在板上、漂浮在透明海面、在海上放松的画面，都和普通海滩照片完全不同。",
          한국어:
            "SUP로 바다 위를 지나가기 때문에 갈 수 있는 조용한 장소에서 촬영합니다. 보드에 앉은 모습, 맑은 수면 위에 떠 있는 모습은 일반 해변 사진과 다른 분위기를 만듭니다.",
        },
      },
      {
        title: {
          EN: "Natural portraits on secret beaches",
          中文: "秘密海滩上的自然写真",
          한국어: "시크릿 비치의 자연스러운 사진",
        },
        area: { EN: "Secret Beach", 中文: "秘密海滩", 한국어: "시크릿 비치" },
        text: {
          EN: "On quiet beaches that are not on typical tourist routes, simply walking, laughing, or looking at the ocean creates natural travel photos. The mood is calm, private, and a little more grown-up.",
          中文: "在人少、一般观光路线不太会去的海滩，只要走路、笑、看海，就能拍出自然的旅行照片。氛围安静、有私人感，也更成熟。",
          한국어:
            "관광객이 적은 조용한 해변에서는 걷고, 웃고, 바다를 바라보는 것만으로 자연스러운 여행 사진이 됩니다. 차분하고 프라이빗하며 조금 더 어른스러운 분위기입니다.",
        },
      },
      {
        title: {
          EN: "Short movies that capture the trip mood",
          中文: "留下旅行氛围的短片",
          한국어: "여행 분위기를 담는 숏무비",
        },
        area: { EN: "Short Movie", 中文: "旅行短片", 한국어: "숏무비" },
        text: {
          EN: "We also capture short videos of the movement, the ocean, and the moments between photos. These clips are made to bring back the breeze, laughter, and feeling of the day.",
          中文: "除了照片，也会记录移动、海边玩耍和拍照间隙的短片。之后回看时，可以想起当天的海风、笑声和旅行氛围。",
          한국어:
            "사진뿐 아니라 움직임, 바다에서 노는 모습, 사진 사이의 순간도 짧은 영상으로 남깁니다. 나중에 보면 그날의 바람과 웃음, 분위기가 떠오르도록 촬영합니다.",
        },
      },
      {
        title: {
          EN: "Special sunset and starry-sky shots",
          中文: "夕阳与星空下的特别照片",
          한국어: "선셋과 별하늘의 특별한 한 장",
        },
        area: { EN: "Special Scene", 中文: "特别场景", 한국어: "스페셜 씬" },
        text: {
          EN: "When the timing is right, we can also shoot with soft sunset light or the starry sky. These photos feel more romantic and memorable than daytime ocean shots.",
          中文: "如果时间合适，也可以利用夕方柔和的光线或星空拍摄。和白天的海景照片不同，会留下更浪漫、更有记忆点的一张。",
          한국어:
            "타이밍이 맞으면 선셋의 부드러운 빛이나 별하늘을 활용한 촬영도 가능합니다. 낮의 바다 사진과는 다른 로맨틱하고 기억에 남는 사진이 됩니다.",
        },
      },
    ],
  },
  "ultimate-extraordinary-miyakojima": {
    title: {
      EN: "For Travelers Seeking the Ultimate Escape in Miyakojima",
      中文: "献给想在宫古岛体验究极非日常的人",
      한국어: "미야코지마에서 궁극의 비일상을 원하는 분께",
    },
    text: {
      EN: "A secret guide to the ultimate Miyakojima day: hidden ocean, scenic shooting, SUP, jet ski, and stars.",
      中文: "秘境海、绝景拍摄、SUP、摩托艇和星空，悄悄介绍宫古岛究极过法。",
      한국어:
        "비경 바다, 절경 촬영, SUP, 제트스키, 별까지 미야코지마의 궁극적인 보내는 법을 소개합니다.",
    },
    description: {
      EN: "A guide for travelers who want to forget everything and enjoy an extraordinary Miyakojima experience.",
      中文: "献给想忘记一切、在宫古岛享受非日常体验的旅行者。",
      한국어:
        "모든 것을 잊고 미야코지마에서 비일상 체험을 즐기고 싶은 여행자를 위한 가이드입니다.",
    },
    leadText: {
      EN: "Miyakojima is more than ordinary sightseeing. Quiet oceans, drone views, secret beaches, and starry nights create a travel day you will not forget.",
      中文: "宫古岛不只是普通观光。安静的大海、无人机视角、秘境海滩和星空，会组成难忘的一天。",
      한국어:
        "미야코지마는 평범한 관광 그 이상입니다. 조용한 바다, 드론 뷰, 비밀 해변, 별이 잊지 못할 하루를 만듭니다.",
    },
    toc: {
      EN: [
        "Morning at a quiet ocean",
        "Scenic and hidden spots during the day",
        "Island dinner and stars at night",
      ],
      中文: ["早晨去人少的海", "白天巡游绝景和秘境", "夜晚用岛饭和星空收尾"],
      한국어: [
        "아침은 조용한 바다로",
        "낮에는 절경과 숨은 장소",
        "밤에는 섬 음식과 별",
      ],
    },
  },
  "yabiji-hidden-paradise": {
    title: {
      EN: "Yabiji: A Hidden Paradise to Visit Once in Your Life",
      中文: "人生中想去一次的秘境：八重干濑",
      한국어: "인생에서 한 번은 가고 싶은 비경, 야비지",
    },
    text: {
      EN: "A special ocean reached by boat, known for clear water and coral reefs.",
      中文: "乘船前往的特别海域，以透明海水和珊瑚礁闻名。",
      한국어: "배로 향하는 특별한 바다, 투명한 물과 산호초가 매력입니다.",
    },
    description: {
      EN: "A guide to Yabiji, a coral reef area near Miyakojima with clear water and an extraordinary ocean experience.",
      中文: "介绍宫古岛附近的珊瑚礁海域八重干濑，透明度高、体验感特别。",
      한국어:
        "미야코지마 근처의 산호초 지대 야비지, 투명한 바다와 특별한 체험을 소개합니다.",
    },
    leadText: {
      EN: "Yabiji is one of the most special oceans to visit from Miyakojima, with endless Miyako blue and coral reefs that photos cannot fully capture.",
      中文: "八重干濑是从宫古岛出发最特别的海域之一，拥有照片无法完全传达的宫古蓝和珊瑚礁。",
      한국어:
        "야비지는 미야코지마에서 갈 수 있는 가장 특별한 바다 중 하나로, 사진만으로는 전해지지 않는 미야코 블루와 산호초가 있습니다.",
    },
    toc: {
      EN: [
        "A special ocean reached by boat",
        "Clear water and coral reefs",
        "Join a tour for safety",
      ],
      中文: ["乘船前往的特别海域", "透明海水和珊瑚礁", "建议参加行程安全体验"],
      한국어: [
        "배로 가는 특별한 바다",
        "투명한 물과 산호초",
        "안전을 위해 투어 참가 추천",
      ],
    },
  },
  "how-to-visit-secret-beaches": {
    title: {
      EN: "How to Reach Secret Beaches Few Travelers Visit",
      中文: "如何前往很少游客去过的秘境海滩",
      한국어: "아직 사람이 많지 않은 비밀 해변에 가는 방법",
    },
    text: {
      EN: "How to visit quiet hidden beaches safely with local guides and private jet ski tours.",
      中文: "介绍如何通过当地向导和私人摩托艇行程安全前往安静秘境海滩。",
      한국어:
        "로컬 가이드와 프라이빗 제트스키 투어로 조용한 비밀 해변에 안전하게 가는 방법입니다.",
    },
    description: {
      EN: "A guide to visiting hidden beaches and secret spots in Miyakojima safely, including tides, reefs, local rules, and guided tours.",
      中文: "介绍如何安全前往宫古岛秘境海滩，包括潮位、礁石、当地规则和向导行程。",
      한국어:
        "조수, 리프, 현지 규칙, 가이드 투어를 포함해 미야코지마 비밀 해변을 안전하게 방문하는 방법입니다.",
    },
    leadText: {
      EN: "Miyakojima has quiet beaches that are not widely shown in guidebooks, but the more hidden a place is, the more important tides, reefs, wind, and local rules become.",
      中文: "宫古岛有许多没有大篇幅出现在指南书上的安静海滩，但越是秘境，潮位、礁石、风向和当地规则越重要。",
      한국어:
        "미야코지마에는 가이드북에 크게 나오지 않는 조용한 해변이 있지만, 숨은 장소일수록 조수, 리프, 바람, 현지 규칙이 중요합니다.",
    },
    toc: {
      EN: [
        "Conditions matter more than the place name",
        "Why local guides help",
        "Go to beaches only reachable by jet ski",
      ],
      中文: [
        "比地点名称更重要的是条件",
        "当地向导的好处",
        "前往只有摩托艇才能抵达的海",
      ],
      한국어: [
        "장소 이름보다 조건이 중요",
        "로컬 가이드와 가는 장점",
        "제트스키로만 갈 수 있는 바다로",
      ],
    },
  },
  "miyakojima-starry-sky-spots": {
    title: {
      EN: "How to See a Star-Filled Sky in Miyakojima: Best Stargazing Spots",
      中文: "如何在宫古岛看满天星空？推荐观星地点",
      한국어: "미야코지마에서 별 가득한 하늘을 보려면? 추천 별보기 스팟",
    },
    text: {
      EN: "Conditions and spots for seeing a beautiful starry sky in Miyakojima.",
      中文: "介绍在宫古岛看美丽星空的条件和推荐地点。",
      한국어:
        "미야코지마에서 아름다운 별하늘을 보기 위한 조건과 추천 장소입니다.",
    },
    description: {
      EN: "A guide to the best stargazing conditions and spots in Miyakojima, including new moon timing, moonlight, dark coastal areas, Higashi-Hennazaki, Ikema Island, and Kurima Island.",
      中文: "宫古岛观星条件和推荐地点指南，包括新月、月光、暗海边、东平安名崎、池间岛和来间岛。",
      한국어:
        "신월, 달빛, 어두운 해안, 히가시헨나자키, 이케마섬, 쿠리마섬 등 미야코지마 별보기 조건과 장소 가이드입니다.",
    },
    leadText: {
      EN: "In Miyakojima, moving just a little away from streetlights can change how many stars you see. New moon timing, clear weather, dark places, and about 90 minutes after sunset are key.",
      中文: "在宫古岛，只要稍微离开街灯，能看到的星星数量就会明显改变。新月、晴天、黑暗地点和日落后约90分钟是关键。",
      한국어:
        "미야코지마에서는 가로등에서 조금만 벗어나도 보이는 별의 수가 달라집니다. 신월, 맑은 날씨, 어두운 장소, 일몰 후 약 90분이 중요합니다.",
    },
    toc: {
      EN: [
        "Conditions for a star-filled sky",
        "Recommended stargazing spots",
        "Book stargazing early in your trip",
      ],
      中文: [
        "看满天星空的条件",
        "推荐观星地点",
        "星空行程建议安排在旅行前半段",
      ],
      한국어: [
        "별 가득한 하늘을 보기 위한 조건",
        "추천 별보기 스팟",
        "별보기 일정은 여행 초반 추천",
      ],
    },
  },
  "miyakojima-today-travel-dashboard": {
    title: {
      EN: "Check These Today to Enjoy Miyakojima 120%",
      中文: "为了120%享受宫古岛，今天要确认的信息",
      한국어: "미야코지마를 120% 즐기기 위해 오늘 확인할 정보",
    },
    text: {
      EN: "Weather, sunrise, sunset, moonrise, moonset, tide, and stargazing index to check before heading out.",
      中文: "出发前想确认的天气、日出日落、月出月落、潮位和星空指数。",
      한국어:
        "출발 전 확인하면 좋은 날씨, 일출・일몰, 월출・월몰, 조위, 별보기 지수입니다.",
    },
    description: {
      EN: "A Miyakojima travel checklist covering today's weather, sunrise and sunset, moonrise and moonset, high and low tide, tide level, and stargazing index.",
      中文: "宫古岛旅行检查清单：今天的天气、日出日落、月出月落、满潮干潮、潮位和星空指数。",
      한국어:
        "오늘의 날씨, 일출・일몰, 월출・월몰, 만조・간조, 조위, 별보기 지수를 정리한 미야코지마 여행 체크리스트입니다.",
    },
    leadText: {
      EN: "In Miyakojima, weather, wind, tides, and moonlight can change the best plan of the day. Check them before heading to the ocean, sunset, or stars.",
      中文: "在宫古岛，天气、风、潮位和月光都会改变当天最适合的玩法。去海边、看夕阳或看星空前请先确认。",
      한국어:
        "미야코지마에서는 날씨, 바람, 조위, 달빛에 따라 그날의 최적 일정이 달라집니다. 바다, 석양, 별을 보러 가기 전 확인하세요.",
    },
    toc: {
      EN: [
        "Today's weather",
        "Sunrise, sunset, moonrise, and moonset",
        "Tide level and stargazing index",
      ],
      中文: ["今天的天气", "日出日落和月出月落", "潮位和星空指数"],
      한국어: ["오늘의 날씨", "일출・일몰과 월출・월몰", "조위와 별보기 지수"],
    },
  },
  "miyakojima-starry-season-2026": {
    title: {
      EN: "When Is Miyakojima's Starry Sky Most Beautiful? Best Dates and Milky Way Info 2026",
      中文: "宫古岛星空什么时候最美？2026推荐日期与银河信息",
      한국어: "미야코지마 별하늘이 예쁜 시기는? 2026 추천 일정・은하수 정보",
    },
    text: {
      EN: "New moon timing, moonlight, Milky Way season, and recommended stargazing dates for 2026.",
      中文: "介绍新月、月光、银河季节和2026年推荐观星日期。",
      한국어: "신월, 달빛, 은하수 시즌, 2026년 추천 별보기 일정을 소개합니다.",
    },
    description: {
      EN: "A 2026 guide to Miyakojima stargazing, including the best conditions, season, Milky Way timing, recommended dates, spots, and FAQ.",
      中文: "2026年宫古岛观星指南，包括最佳条件、季节、银河时间、推荐日期、地点和常见问题。",
      한국어:
        "최적 조건, 시즌, 은하수 시기, 추천 날짜, 장소, FAQ를 담은 2026년 미야코지마 별보기 가이드입니다.",
    },
    leadText: {
      EN: "For beautiful stars in Miyakojima, the key conditions are around the new moon, no moonlight, clear skies, about 90 minutes after sunset, and a dark location.",
      中文: "想在宫古岛看美丽星空，关键是新月前后、没有月光、晴天、日落后约90分钟和街灯少的地点。",
      한국어:
        "미야코지마에서 아름다운 별을 보려면 신월 전후, 달빛이 없는 시간, 맑은 하늘, 일몰 후 약 90분, 어두운 장소가 중요합니다.",
    },
    toc: {
      EN: [
        "Best conditions for Miyakojima stars",
        "Best season and Milky Way timing",
        "Recommended 2026 stargazing dates",
        "FAQ",
      ],
      中文: [
        "宫古岛星空最佳条件",
        "推荐季节和银河时间",
        "2026推荐观星日期",
        "常见问题",
      ],
      한국어: [
        "미야코지마 별보기 최적 조건",
        "추천 시즌과 은하수 시기",
        "2026년 추천 별보기 날짜",
        "FAQ",
      ],
    },
  },
  "full-moon-party-japan-miyakojima": {
    title: {
      EN: "What Is the Full Moon Party That Exists in Japan?",
      中文: "日本也有满月派对？",
      한국어: "일본에도 있는 풀문 파티란?",
    },
    text: {
      EN: "A Miyakojima night event where people gather under the full moon in white.",
      中文: "介绍满月夜穿白色服装聚集的宫古岛非日常夜间活动。",
      한국어:
        "보름달 밤, 흰 옷을 입고 모이는 미야코지마의 특별한 나이트 이벤트입니다.",
    },
    description: {
      EN: "An introduction to Miyakojima's Full Moon Party in Japan, including the dress code, atmosphere, what to expect, and what to check before joining.",
      中文: "介绍日本宫古岛的满月派对，包括服装要求、氛围、玩法和参加前需要确认的事项。",
      한국어:
        "일본 미야코지마의 풀문 파티를 드레스 코드, 분위기, 즐길 거리, 참가 전 확인 사항과 함께 소개합니다.",
    },
    leadText: {
      EN: "When people hear Full Moon Party, many think of Koh Phangan in Thailand. In Japan, Miyakojima also has full-moon-themed events where music, fire, island air, and the full moon create a special night.",
      中文: "说到满月派对，很多人会想到泰国帕岸岛。其实在日本宫古岛，也有以满月为主题的活动，音乐、火光、岛屿空气和满月交织成特别的夜晚。",
      한국어:
        "풀문 파티라고 하면 태국 팡안섬을 떠올리는 분이 많지만, 일본 미야코지마에도 보름달을 테마로 한 이벤트가 있습니다. 음악, 불빛, 섬의 공기, 보름달이 특별한 밤을 만듭니다.",
    },
    toc: {
      EN: [
        "Is there a Full Moon Party in Japan?",
        "What kind of atmosphere is it?",
        "What to check before joining",
      ],
      中文: ["日本有满月派对吗？", "是什么样的氛围？", "参加前要确认什么"],
      한국어: [
        "일본에도 풀문 파티가 있나요?",
        "어떤 분위기인가요?",
        "참가 전 확인할 점",
      ],
    },
  },
};
